<template>
  <div id="app">
    <TheHeaderBS46
      :navbar-items="headerNavbarList"
      :is-auth-user="isAuthUser"
      :teacher-role-id="teacherRoleId"
      :expert-role-id="expertRoleId"
      :user="user"
      variant="light"
      expand
      expand-width-point="lg"
      sticky
      shadow
    />
    <main class="d-flex flex-column">
      <router-view
        :teacher-role-id="teacherRoleId"
        :expert-role-id="expertRoleId"
        :news-list="newsList"
        :url="url"
        :app-loaded="appLoaded"
        :user="user"
        :user-selected-role-id="userSelectedRoleId"
        :teacher-info="teacherInfo"
        :expert-info="expertInfo"
        :is-auth-user="isAuthUser"
        :auth-error="authError"
        :auth-loader="authLoader"
        :profile-loader="profileLoader"
        :apps-table="appsTable"
        :app-form="appForm"
        :app-form-options="i18n"
        :apps-loader="appsLoader"
        :messages-table="messagesTable"
        :message-form="messageForm"
        :message-form-options="i18n"
        :messages-loader="messagesLoader"
        :expertises-table="expertisesTable"
        :expertise-form="expertiseForm"
        :expertise-form-options="i18n"
        :messages-service-id="messagesServiceId"
        :expertises-service-id="expertisesServiceId"
        :apps-service-id="appsServiceId"
        :expertises-loader="expertisesLoader"
        :analytics-table="analyticsTable"
        :analytic-form-options="i18n"
        :analytics-loader="analyticsLoader"
        :is-loading="isLoading"
        :logs-table="logsTable"
        :log-form="logForm"
        :log-form-options="i18n"
        :logs-loader="logsLoader"
        :dictionaries="dictionaries"
        :file-resources="fileResources"
        :expertises-schedule="expertisesSchedule"
        :service="service"
        :loaded-service-form="loadedServiceForm"
        @sign-in-local="signInLocal($event)"
        @sign-in-esia="getLogin"
        @sign-out="signOut"
        @set-role="setRole($event)"
        @edit-profile="editProfile"
        @set-teacher="setTeacher"
        @set-expert="setExpert"
        @create-new-app="createNewApp(appsServiceId)"
        @open-existing-app="openExistingApp(appsServiceId, $event)"
        @create-new-message="createNewMessage(messagesServiceId)"
        @open-existing-message="openExistingMessage(messagesServiceId, $event)"
        @open-existing-expertise="
          openExistingExpertise(expertisesServiceId, $event)
        "
        @open-existing-log="openExistingLog(logsServiceId, $event)"
        @change-apps-page-size="
          changePageSize(appsTable, $event, appsServiceId)
        "
        @change-apps-page="changePage(appsTable, $event, appsServiceId)"
        @change-apps-filter="changeFilter(appsTable.filters, $event)"
        @apply-apps-filter="getApps"
        @clear-apps-filter="clearAppsFilter"
        @change-message-page-size="
          changePageSize(messagesTable, $event, messagesServiceId)
        "
        @change-message-page="
          changePage(messagesTable, $event, messagesServiceId)
        "
        @change-messages-filter="changeFilter(messagesTable.filters, $event)"
        @apply-messages-filter="getMessages"
        @clear-messages-filter="clearMessagesFilter"
        @change-expertises-page-size="
          changePageSize(expertisesTable, $event, expertisesServiceId)
        "
        @change-expertises-page="
          changePage(expertisesTable, $event, expertisesServiceId)
        "
        @change-expertises-filter="
          changeFilter(expertisesTable.filters, $event)
        "
        @apply-expertises-filter="getExpertises"
        @clear-expertises-filter="clearExpertisesFilter"
        @invoke-action="invokeAction($event)"
        @sort-table="sortTable($event.tableName, $event.sortedColumnIndex)"
        @show-service-first-form="showServiceFirstForm($event)"
        @show-app-form="showAppForm($event)"
        @change-app-form="changeAppForm($event)"
        @reset-app-form="resetAppForm"
        @show-app-loader="loaderStart(appsLoader, $event)"
        @hide-app-loader="loaderFinish(appsLoader)"
        @update-registries="updateRegistries"
        @set-application-stamp="setApplicationStamp($event)"
        @get-home-view-data="getHomeViewData"
        @get-account-view-data="getAccountViewData($event)"
      />
      <ModalBootstrapCustomBS46 modal-id="notify" header>
        <template v-slot:modal-title> Оповещение </template>
        <template v-slot:modal-body>
          <!--          Уведомления!-->
          <template v-if="false">
            <transition-group
              if="false"
              name="fade-out-group"
              tag="div"
              class="accordion"
              id="accordionMessages"
            >
              <MessagesAccordionItemBS46
                v-for="message of sortedMessagesList"
                :key="message.id"
                :message="message"
                @read-message="readMessage(message.id)"
                @delete-message="deleteMessage(message.id)"
              />
            </transition-group>
            <div
              v-if="messagesList.length === 0"
              class="alert alert-secondary mb-0"
              role="alert"
            >
              У вас отсутствуют уведомления!
            </div>
          </template>
          <template v-else>
            <div class="alert alert-secondary mb-0" role="alert">
              Время рабочей сессии завершено. Для продолжения работы необходимо
              повторно пройти авторизацию
            </div>
          </template>
        </template>
      </ModalBootstrapCustomBS46>
    </main>
    <TheFooterBS46 :footer-contacts="footerContacts" />
  </div>
</template>

<script>
import axios from "axios";
import TheHeaderBS46 from "./components/TheHeaderBS46";
import TheFooterBS46 from "./components/TheFooterBS46";
import { Modal } from "bootstrap";
import ModalBootstrapCustomBS46 from "./components/universal/ModalBootstrapCustomBS46";
import MessagesAccordionItemBS46 from "./components/MessagesAccordionItemBS46";
import $ from "jquery";
import { startSessionInterval, stopSessionInterval, setOnSessionExpired } from "./utils/session.js";

export default {
  name: "TheApp",
  components: {
    MessagesAccordionItemBS46,
    ModalBootstrapCustomBS46,
    TheFooterBS46,
    TheHeaderBS46,
  },

  data() {
    return {
      // Оптимизация: выносим большие статические объекты из реактивных данных
      staticData: Object.freeze({
        headerNavbarList: [
          {
            id: 1,
            title: "Главная",
            type: "link",
            link: "/",
            forAll: true,
            forAuthUser: true,
          },
        ],
      }),
      //! ЗАМЕНИТЬ ПЕРЕД СБОРКОЙ НА ПРОД
      // url: "https://new-irkutsk-teachers-ok.isands.ru/", // test
      url: "https://teachers.coko38.ru/", // prod

      // url: "http://192.168.16.102:8180/",
      // url: "http://172.16.55.49:8180/",

      //! ЗАМЕНИТЬ ПЕРЕД СБОРКОЙ НА ПРОД
      // urlAdd: "https://new-irkutsk-teachers-ok.isands.ru/api-teacher/api/",  // test
      urlAdd: "https://teachers.coko38.ru/api-teacher/api/",  // prod

      // urlAdd: "http://192.168.16.102:8180/api-teacher/api/",
      // urlAdd: "http://172.16.55.49:8180/api-teacher/api/",
      user: {
        isAuth: false,
        signInData: {
          login: "",
          password: "",
        },
        shortInfo: {
          orgId: null,
          roleId: null,
          typeAuth: "",
          userId: null,
          userName: "",
        },
        fullInfo: {
          userId: null,
          shortUserName: "",
          roles: [],
          userOrganizations: [],
          userData: {
            oid: null,
            lastName: "",
            firstName: "",
            middleName: "",
            birthDate: "",
            birthPlace: null,
            gender: "",
            snils: "",
            inn: "",
            updatedOn: null,
            citizenship: null,
            status: null,
            trusted: false,
            verifying: false,
            avatar: null,
          },
          contacts: [
            {
              type: "",
              value: "",
              verifyingValue: null,
              vrfStu: null,
              vrfValStu: null,
            },
          ],
          addresses: null,
          esiaDocuments: null,
          other: {},
        },
        selectedRole: {
          id: null,
          key: "",
          label: "",
        },
      },
      userSelectedRoleId: "",
      isFirstLoad: true,
      appLoaded: false,
      loadersDelay: 1000,

      // Авторизация
      esiaLogoutLink: "",
      authError: {
        type: "",
        text: "",
      },
      authLoader: {
        isLoading: false,
        isResponse: false,
        comment: "",
        theme: "secondary",
      },

      // Профиль пользователя
      profileLoader: {
        isLoading: false,
        isResponse: false,
        comment: "",
        theme: "secondary",
      },

      // Заявления
      //! ЗАМЕНИТЬ ПЕРЕД СБОРКОЙ НА ПРОД
      appsServiceId: 22, // prod 10, 22
      // appsServiceId: 29,  // test v1 =2 , v4 =29

      appsResponse: [],
      appsTable: {
        id: "appsTable",
        service: 10,
        columnsList: [
          { title: "№ заявления", name: "id", sorted: true },
          { title: "Наименование услуги", name: "service" },
          { title: "Дата создания", name: "createDate", sorted: true },
          { title: "Номер ЕПГУ", name: "epguNum", sorted: true },
          { title: "Статус", name: "status", sorted: true },
          {
            title: "Дата изменения статуса",
            name: "changeDate",
            sorted: true,
          },
        ],
        primaryColumn: "№ заявления",
        rowsList: [],
        sortColumn: "id",
        ascendingSortOrder: false,
        filters: [
          {
            id: "1",
            label: "№ заявления",
            type: "input",
            subtype: "number",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            value: null,
          },
          {
            id: "3",
            label: "Дата создания",
            type: "range",
            subtype: "date",
            itemsList: [
              { label: " c", value: null },
              { label: " по", value: null },
            ],
            width: 12,
            responsive: "col-sm-8 col-md-6 col-lg-4",
          },
          {
            id: "4",
            label: "№ ЕПГУ",
            type: "input",
            subtype: "number",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            value: null,
          },
          {
            id: "5",
            label: "Статус",
            type: "select",
            itemsList: [
              { id: 1, value: 1, label: "Черновик" },
              { id: 2, value: 2, label: "В работе" },
              { id: 3, value: 3, label: "Обработано" },
              { id: 4, value: 4, label: "Архивная" },
            ],
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            values: [],
          },
          {
            id: "6",
            label: "Дата изменения статуса",
            type: "range",
            subtype: "date",
            itemsList: [
              { label: " c", value: null },
              { label: " по", value: null },
            ],
            width: 12,
            responsive: "col-sm-8 col-md-6 col-lg-4",
          },
        ],
        pagination: {
          itemsTotal: 0,
          page: 1,
          pageSize: 10,
          itemsPerPage: [10, 25, 50],
        },
      },
      appsLoader: {
        isLoading: false,
        isResponse: false,
        comment: "",
        theme: "secondary",
      },
      appForm: {
        active: false,
        data: {},
        form: {
          actions: [],
          id: 0,
          modelId: 0,
          scheme: {},
        },
        id: 0,
        orderId: "",
        status: "",
      },

      // Сообщения
      //! ЗАМЕНИТЬ ПЕРЕД СБОРКОЙ НА ПРОД
      messagesServiceId: 12, // prod
      // messagesServiceId: 11,   // test

      messagesResponse: [],
      messagesTable: {
        id: "messagesTable",
        // service: 12,
        service: 11,
        columnsList: [
          { title: "№ сообщения", name: "id", sorted: true },
          {
            title: "Дата создания сообщения",
            name: "createDate",
            sorted: true,
          },
          { title: "Тема", name: "theme" },
          {
            title: "Дата входа в статус",
            name: "changeDate",
            sorted: true,
          },
          { title: "Статус", name: "status", sorted: true },
          {
            title: "Срок отправки ответа",
            name: "responseLimit",
          },
        ],
        primaryColumn: "№ сообщения",
        rowsList: [],
        sortColumn: "id",
        ascendingSortOrder: false,
        filters: [
          {
            id: "1",
            label: "№ сообщения",
            type: "input",
            subtype: "number",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            value: null,
          },
          {
            id: "2",
            label: "Дата создания сообщения",
            type: "range",
            subtype: "date",
            itemsList: [
              { label: " c", value: null },
              { label: " по", value: null },
            ],
            width: 12,
            responsive: "col-sm-8 col-md-6 col-lg-4",
          },
          {
            id: "3",
            label: "Тема",
            type: "input",
            subtype: "text",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            value: "",
          },
          {
            id: "4",
            label: "Дата входа в статус",
            type: "range",
            subtype: "date",
            itemsList: [
              { label: " с", value: null },
              { label: " по", value: null },
            ],
            width: 12,
            responsive: "col-sm-8 col-md-6 col-lg-4",
          },
          {
            id: "5",
            label: "Статус",
            type: "select",
            itemsList: [
              { id: 1, value: 1, label: "Черновик" },
              { id: 2, value: 2, label: "В работе" },
              { id: 3, value: 3, label: "Обработано" },
              { id: 4, value: 4, label: "Архивная" },
            ],
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            values: [],
          },
          {
            id: "6",
            label: "Срок отправки ответа",
            type: "range",
            subtype: "date",
            itemsList: [{ label: " с" }, { label: " по" }],
            width: 12,
            responsive: "col-sm-8 col-md-6 col-lg-4",
            value: null,
          },
        ],
        pagination: {
          itemsTotal: 0,
          page: 1,
          pageSize: 10,
          itemsPerPage: [10, 25, 50],
        },
      },
      messagesLoader: {
        isLoading: false,
        isResponse: false,
        comment: "",
        theme: "secondary",
      },
      messageForm: {
        active: false,
        data: {},
        form: {
          actions: [],
          id: 0,
          modelId: 0,
          scheme: {},
        },
        id: 0,
        orderId: "",
        status: "",
      },

      // "Экспертизы"
        //! ЗАМЕНИТЬ ПЕРЕД СБОРКОЙ НА ПРОД
      expertisesServiceId: 11, // prod
      // expertisesServiceId: 1, // test
      
      expertisesResponse: [],
      expertisesTable: {
        id: "expertisesTable",
        service: 11,
        columnsList: [
          { title: "№ заявления", name: "id", sorted: true },
          {
            title: "ФИО педагогического работника",
            name: "teacherFullname",
          },
          {
            title: "Дата начала экспертизы",
            name: "startDate",
          },
          // {
          //   title: "Срок окончания экспертизы",
          //   name: "expertiseLimit",
          // },
          {
            title: "Дата окончания экспертизы",
            name: "expertiseFinishDate",
          },
          {
            title: "Результат экспертизы",
            name: "expertiseResult",
          },
          { title: "Статус", name: "status", sorted: true },
        ],
        primaryColumn: "№ заявления",
        rowsList: [],
        sortColumn: "id",
        ascendingSortOrder: true,
        filters: [
          {
            id: "1",
            label: "№ заявления",
            type: "input",
            subtype: "number",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            value: null,
          },
          {
            id: "2",
            label: "ФИО пед.работника",
            type: "input",
            subtype: "text",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            value: null,
          },
          {
            id: "3",
            label: "Дата начала экспертизы",
            type: "range",
            subtype: "date",
            itemsList: [
              { label: " c", value: null },
              { label: " по", value: null },
            ],
            width: 12,
            responsive: "col-sm-8 col-md-6 col-lg-4",
          },
          {
            id: "4",
            label: "Срок окончания экспертизы",
            type: "input",
            subtype: "number",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            value: null,
          },
          {
            id: "5",
            label: "Дата окончания экспертизы",
            type: "range",
            subtype: "date",
            itemsList: [
              { label: " c", value: null },
              { label: " по", value: null },
            ],
            width: 12,
            responsive: "col-sm-8 col-md-6 col-lg-4",
          },
          {
            id: "6",
            label: "Результат экспертизы",
            type: "select",
            itemsList: [
              { id: 1, value: 1, label: "Положительный" },
              { id: 2, value: 2, label: "Отрицательный" },
              { id: 3, value: 3, label: "Прекращена" },
            ],
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            values: [],
          },
          {
            id: "7",
            label: "Статус",
            type: "select",
            itemsList: [
              { id: 1, value: 1, label: "Черновик" },
              { id: 2, value: 2, label: "В работе" },
              { id: 3, value: 3, label: "Обработано" },
              { id: 4, value: 4, label: "Архивная" },
            ],
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
            values: [],
          },
        ],
        pagination: {
          itemsTotal: 0,
          page: 1,
          pageSize: 10,
          itemsPerPage: [10, 25, 50],
        },
      },
      expertisesLoader: {
        isLoading: false,
        isResponse: false,
        comment: "",
        theme: "secondary",
      },
      expertiseForm: {
        active: false,
        data: {},
        form: {
          actions: [],
          id: 0,
          modelId: 0,
          scheme: {},
        },
        id: 0,
        orderId: "",
        status: "",
      },

      // "Аналитика"
      analyticsServiceId: 2,
      analyticsTable: {
        id: "analyticsTable",
        columnsList: [
          {
            title: "Количество проведенных экспертиз",
            name: "expertisesTotal",
          },
          {
            title: "Количество положительных результатов",
            name: "expertisesPositiveResults",
          },
          {
            title: "Количество отрицательных результатов",
            name: "expertisesNegativeResults",
          },
          {
            title: "Количество несовпадений",
            name: "expertisesEqualResults",
          },
        ],
        primaryColumn: "Количество проведенных экспертиз",
        rowsList: [],
        sortColumn: "",
        ascendingSortOrder: false,
        filters: [
          {
            id: "1",
            label: "№ заявления",
            type: "input",
            subtype: "number",
            width: 4,
            value: "245",
            required: true,
            disabled: true,
          },
          {
            id: "2",
            label: "Квалификация",
            type: "select",
            itemsList: [
              { id: 1, text: "Вторая" },
              { id: 2, text: "Первая" },
              { id: 3, text: "Высшая" },
            ],
          },
          {
            id: "3",
            label: "Показать только архивные",
            type: "checkbox",
            width: 12,
          },
          {
            id: "4",
            label: "",
            type: "range",
            subtype: "date",
            itemsList: [{ label: "Дата начала" }, { label: "Дата окончания" }],
            width: 6,
          },
        ],
        pagination: {
          itemsTotal: 0,
          page: 1,
          pageSize: 10,
          itemsPerPage: [10, 25, 50],
        },
      },
      analyticsLoader: {
        isLoading: false,
        isResponse: false,
        comment: "",
        theme: "secondary",
      },

      // "Журнал действий"
      logsServiceId: 2,
      auditResponse: [],
      logsTable: {
        id: "logsTable",
        columnsList: [
          { title: "Id записи", name: "id" },
          { title: "Дата события", name: "eventDate" },
          { title: "Описание", name: "eventDescription" },
          { title: "Событие", name: "eventName" },
          { title: "Изменения", name: "eventChanges" },
        ],
        primaryColumn: "Id записи",
        rowsList: [],
        sortColumn: "id",
        ascendingSortOrder: false,
        filters: [
          {
            id: "1",
            label: "Id записи",
            type: "input",
            subtype: "number",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
          },
          {
            id: "2",
            label: "Дата события",
            type: "range",
            subtype: "date",
            itemsList: [{ label: " с" }, { label: " по" }],
            width: 12,
            responsive: "col-sm-8 col-md-6 col-lg-4",
          },
          {
            id: "3",
            label: "Описание",
            type: "input",
            subtype: "text",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
          },
          {
            id: "4",
            label: "Событие",
            type: "select",
            itemsList: [
              { id: 1, text: "Изменение записи" },
              { id: 2, text: "Проведение аттестации" },
              { id: 3, text: "Удаление записи" },
              { id: 4, text: "Создание записи" },
            ],
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
          },
          {
            id: "5",
            label: "Изменения",
            type: "input",
            subtype: "text",
            width: 12,
            responsive: "col-sm-4 col-md-3 col-lg-2",
          },
        ],
        pagination: {
          itemsTotal: 0,
          page: 1,
          pageSize: 10,
          itemsPerPage: [10, 25, 50],
        },
      },
      logsLoader: {
        isLoading: false,
        isResponse: false,
        comment: "",
        theme: "secondary",
      },
      logForm: {
        active: false,
        data: {},
        form: {
          actions: [],
          id: 0,
          modelId: 0,
          scheme: {},
        },
        id: 0,
        orderId: "",
        status: "",
      },

      // Текущее заявление
      i18n: {
        lng: "ru",
        ru: {
          Name: "Имя",
          "Last name": "Фамилия",
          dict: "Тип заявителя",
          "Type to search": "Поиск...",
          "Last name is required": "Фамилия - это обязательное поле",
          "No results found": "Поиск не дал результатов",
          "is required": "обязательное поле",
          Number: "Число",
          Submit: "Подтвердить",
          Layout: "Расположение",
          "Drag and Drop a form component": "Переместите компонент сюда",
          "No Matches Found": "Ничего не найдено",
          "Text Field": "Текстовое поле",
          Email: "Электронная почта",
          "Text Area": "Текстовая область",
          "Phone Number": "Номер телефона",
          Checkbox: "Флажок",
          Select: "Выпадающий список",
          Radio: "Радио кнопка",
          Url: "Ссылка",
          "Data Map": "Ключ - Значение",
          "Data Grid": "Динамический список",
          "Edit Grid": "Сетка данных",
          Table: "Таблица",
          "Date / Time": "Дата / Время",
          Day: "День",
          Time: "Время",
          File: "Файл",
          Signature: "Подпись",
          Content: "Контент",
          Columns: "Столбцы",
          "Field Set": "Набор полей",
          Panel: "Панель",
          Tabs: "Вкладки",
          Well: "Лист",
          Label: "Название",
          "Please fix the following errors before submitting":
            "Пожалуйста исправьте ошибки перед теп как продолжить",
          "Email: Email must be a valid email.": "Не правильный e-mail",
          Placeholder: "Заполнитель",
          Description: "Описание",
          Tooltip: "Подсказка",
          "To add a tooltip to this field,enter text here.":
            "Введите подсказку здесь",
          "Input Mask": "Маска ввода",
          Hidden: "Скрытый",
          "Hide Label": "Скрыть название",
          Save: "Сохранить",
          Cancel: "Отмена",
          Remove: "Удалить",
          Preview: "Предварительный просмотр",
          Disabled: "Отключен",
          Validation: "Проверка",
          Data: "Данные",
          "Property Name": "Имя переменной",
          Display: "Отображение",
          Widget: "Тип компонента",
          required: "обязательно для заполнения",
          pattern: "не соответствует маске!",
          error: "Пожалуйста исправьте ошибки прежде чем продолжить.",
          submitError: "Пожалуйста исправьте все ошибки прежде чем продолжить.",
          invalid_regex: "не соответствует маске!",
          mask: "{{field}} не соответствует маске.",
          valueIsNotAvailable: "неправильное значение.",
          Edit: "Редактировать",
          "Label Position": "Расположение",
          "Label Width": "Ширина",
          "Label Margin": "Отступ",
          Prefix: "Прификс",
          Suffix: "Суффикс",
          "Custom CSS Class": "CSS класс",
          "Show Word Counter": "Показать счетчик слов",
          "Show Character Counter": "Показать счетчик символов",
          "Hide Input": "Скрыть ввод",
          "Initial Focus": "Начальный фокус",
          "Allow Spellcheck": "Проверка орфографии",
          "Modal Edit": "Показать во всплывающем окне",
          "Tab Index": "Индекс вкладки",
          Autocomplete: "Автозавершение",
          month: "Месяц",
          day: "День",
          year: "Год",
          january: "Январь",
          february: "Февраль",
          march: "Март",
          april: "Апрель",
          may: "Май",
          june: "Июнь",
          july: "Июль",
          July: "Июль",
          august: "Август",
          september: "Сентябрь",
          october: "Октябрь",
          november: "Ноябрь",
          december: "Декабрь",
          next: "Далее",
          previous: "Назад",
          cancel: "Отмена",
          submit: "Отправить",
          "File Name": "Имя файла",
          Size: "Размер",
          "Add Another": "Добавить",
          "Drop files to attach,": "Перетащите файл сюда,",
          or: "или",
          browse: "выберите с диска",
        },
      },
      isLoading: false,
      loadingComment: "Загрузка заявления",
      successComment: "Заявление успешно загружено!",
      isResponse: false,
      isAlertVisible: false,
      isValidFormData: false,

      isResponseByForm: false,

      // Замораживаем статические данные для экономии памяти
      headerNavbarList: Object.freeze([
        {
          id: 1,
          title: "Личный кабинет",
          type: "link",
          link: "/account",
          forAuthUser: true,
        },
      ]),
      // Замораживаем статические новости для экономии памяти
      newsList: Object.freeze([
        {
          id: 1,
          title:
            'Разработан и подключен ВС "Передача статусов и результатов предоставления государственных и муниципальных услуг"',
          text: 'Протестировано взаимодействие с ЕЛК по формату вида сведений "Передача статусов и результатов предоставления государственных и муниципальных услуг".',
          datePublication: "28.07.2022",
        },
        {
          id: 2,
          title: "Активирована новая версия услуги",
          text:
            'В системе активирована новая версия услуги "Организация отдыха детей в каникулярное время" по версии 1.0.2' +
            "При личном обращении заявителей требуется оформлять заявления по нововй версии формы заявления.",
          datePublication: "01.06.2022",
        },
        {
          id: 3,
          title: "Зарегистрирована новая версия услуги",
          text:
            'В системе зарегистрирована новая версия услуги "Организация отдыха детей в каникулярное время" по версии 1.0.2' +
            "Ведутся работы по выводу новой версии в продуктивную работу.",
          datePublication: "27.05.2022",
        },
      ]),
      messagesList: [],
      organization: {
        addresses: [],
        contacts: [],
      },
      // Заморозим статические данные для оптимизации памяти
      footerContacts: Object.freeze([
        {
          id: 1,
          title: "Министерство образования Иркутской области",
          type: "text",
          link: "/",
        },
        {
          id: 2,
          title: "Адрес: 664027, Россия, г. Иркутск, ул. Российская, д. 21",
          type: "text",
          link: "/",
        },
        {
          id: 3,
          title: "Приемная:  8 (3952) 33-13-33, Канцелярия: 8 (3952) 24-09-72",
          type: "text",
          link: "/",
        },
        {
          id: 4,
          title: "E-mail: obraz@38edu.ru",
          type: "text",
          link: "/",
        },
        {
          id: 5,
          title:
            "Государственное автономное учреждение Иркутской области «Центр оценки профессионального мастерства, квалификаций педагогов и мониторинга качества образования»",
          type: "text",
          link: "/",
        },
        {
          id: 6,
          title:
            "Адрес: 664023, Иркутская область, город Иркутск, улица Лыткина, дом 75/1",
          type: "text",
          link: "/",
        },
        {
          id: 7,
          title: "Телефон: +7 (3952) 500-287",
          type: "text",
          link: "/",
        },
        {
          id: 8,
          title: "Email: att.ped@coko38.ru",
          type: "text",
          link: "/",
        },
      ]),

      modal: null,
      vueForm: null,

      // newTeacher: {
      //   id: 39502,
      //   familyName: "Васильев",
      //   name: "Михаил",
      //   middleName: "Анатольевич",
      //   birthday: "1980-03-08T00:00:00.000+00:00",
      //   snils: "07397683725",
      //   citizenship: "Российская Федерация",
      //   mail: "mgp-nsk@yandex.ru",
      //   phone: "+7(903)1234567",
      //   gender: "1",
      //   municipality: "Город Зима",
      //   subjectArea: "Математика",
      //   regAddress: "ул.Коммунистическая",
      //   factAddress: "ул.Новая",
      //   docname: "Паспорт гражданина РФ",
      //   docSeries: "5000",
      //   docNumber: "123456",
      //   issueDate: "2001-02-15T00:00:00.000+00:00",
      //   docValidate: "2051-02-15T00:00:00.000+00:00",
      //   issueOrg: "010",
      //   mailAgree: false,
      //   workHistoryList: [],
      //   attestationsResultList: [],
      //   fileList: [],
      // },
      // newExpert: {
      //   id: 39502,
      //   familyName: "Васильев",
      //   name: "Михаил",
      //   middleName: "Анатольевич",
      //   snils: "07397683725",
      //   mail: "mgp-nsk@yandex.ru",
      //   phone: "+7(903)1234567",
      //   position: "Специалист отдела образования",
      //   municipality: "Город Зима",
      //   organization: "Администрация города Зима",
      //   subjectArea: "Математика",
      //   rating: "5",
      //   status: true,
      //   mailAgree: true,
      //   numberExaminations: 32,
      //   numberPositiveResult: 16,
      //   numberNegativeResult: 4,
      //   numberCoincidences: 12,
      // },

      //! ЗАМЕНИТЬ ПЕРЕД СБОРКОЙ НА ПРОД
      teacherRoleId: 39707, // prod
      // teacherRoleId: 43671,  // test

      //! ЗАМЕНИТЬ ПЕРЕД СБОРКОЙ НА ПРОД
      expertRoleId: 39927, // prod
      // expertRoleId: 43672,   // test

      teacherInfo: {
        id: 0,
        familyName: "",
        name: "",
        middleName: "",
        birthday: "",
        snils: "",
        citizenship: "",
        mail: "",
        phone: "",
        gender: "",
        municipality: "",
        subjectArea: "",
        regAddress: "",
        factAddress: "",
        docName: "",
        docSeries: "",
        docNumber: "",
        issueDate: "",
        docValidate: "",
        issueOrg: "",
        mailAgree: false,
        workHistoryList: [],
        attestationsResultList: [],
        fileList: [],
      },
      expertInfo: {
        id: 0,
        familyName: "",
        name: "",
        middleName: "",
        snils: "",
        mail: "",
        phone: "",
        position: "",
        municipality: "",
        organization: "",
        subjectArea: "",
        rating: "",
        status: false,
        mailAgree: false,
        numberExaminations: 0,
        numberPositiveResult: 0,
        numberNegativeResult: 0,
        numberCoincidences: 0,
      },

      dictionaries: {
        gender: [],
        subjectArea: [],
        jobGroups: [],
        municipalEntityIrkutsk: [],
        DocumentPersonal: [],
        statusModel_2: [],
        statusModel_1: [],
        statusModel_3: [],
        resultExpert: [],
        topic: [],
      },

      // Документы для работы с системой
      fileResources: [],

      expertisesSchedule: "",

      authIntervalId: null,

      // From 72
      //! ЗАМЕНИТЬ ПЕРЕД СБОРКОЙ НА ПРОД
      config: {
        // url: "/",
        url: "https://teachers.coko38.ru/", // prod
        // url: "https://new-irkutsk-teachers-ok.isands.ru/",  // test

        // url: "http://192.168.16.102:8180/",
        // url: "http://172.16.55.49:8180/",
        esiaSignInUrl: "",
        user: {
          auth: false,
          shortInfo: {
            userId: null,
            orgId: null,
            roleId: null,
            userName: "",
            typeAuth: "",
            redirectUrl: "",
          },
          fullInfo: {
            userId: null,
            shortUserName: "",
            roles: [],
            userOrganizations: [],
            userData: {},
            contacts: [],
            addresses: null,
            esiaDocuments: null,
            other: {},
          },
          selectedRole: {
            id: null,
            key: "",
            label: "",
          },
          selectedOrg: {
            id: null,
            key: "",
            label: "",
          },
          roleSelector: {
            id: "userRoleSelector",
            label: "",
            type: "select",
            itemsList: [],
            width: 4,
            responsive: "col-sm-3 col-md-2 mb-0 p-0",
            defaultValueLabel: "Выберите роль",
            horizontal: false,
            horizontalWidth: {
              label: {
                width: 4,
                responsive: "col-sm-5",
              },
              field: {
                width: 8,
                responsive: "col-sm-7",
              },
            },
            values: [],
          },
          orgSelector: {
            id: "orgRoleSelector",
            label: "",
            type: "select",
            itemsList: [
              { id: 1, value: 1, label: "Свидетельство о браке" },
              { id: 2, value: 2, label: "Водительское удостоверение" },
            ],
            width: 12,
            responsive: "col-sm-9 col-md-6 mb-0 p-0",
            defaultValueLabel: "Выберите организацию",
            horizontal: false,
            horizontalWidth: {
              label: {
                width: 4,
                responsive: "col-sm-5",
              },
              field: {
                width: 8,
                responsive: "col-sm-7",
              },
            },
            values: [],
          },
        },
        authModalMode: "",
        theme: "primary",
        adminSettings: {
          notification: {
            publishNeed: false,
            publicationImmediately: true,
            publicationStartDate: "",
            publicationFinishManual: true,
            publicationFinishDate: "",
            notificationText: "",
            notificationFontSize: 1,
            notificationColor: 4,
          },
          server: {
            ownServer: true,
            externalServerUrl: "",
          },
          logo: {
            image: {
              file: "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",
              fileName: "iss_logo_white.png",
            },
            logoBrand: "Информационные системы и сервисы",
          },
          footer: {
            contacts: {
              phone: "8-383-354-1011",
              email: "info@isands.ru",
            },
            links: [
              {
                name: "Новости",
                url: "/news",
              },
              {
                name: "Поддержка юридических лиц",
                url: "/measures",
              },
              {
                name: "Поддержка физических лиц",
                url: "/measures",
              },
            ],
            copyright: {
              publication: true,
              text: "© Информационные системы и сервисы, 2022",
            },
          },
        },
        keepAliveSession: false,
      },
      configLoaded: false,
      authForm: {
        login: "",
        password: "",
        passwordVisibility: false,
        authError: {
          type: "",
          text: "",
        },
      },
      /*messagesList: [
        
  
      ],*/
      apps: {
        id: "appsTable",
        service: 2,
        columnsList: [
          { title: "№ заявления", name: "id", sorted: true },
          { title: "Наименование услуги", name: "service" },
          { title: "Дата создания", name: "createDate", sorted: true },
          { title: "Номер ЕПГУ", name: "epguNum", sorted: true },
          { title: "Статус", name: "status", sorted: true },
          {
            title: "Дата изменения статуса",
            name: "changeDate",
            sorted: true,
          },
        ],
        primaryColumn: "№ заявления",
        rowsList: [],
        sortColumn: "id",
        ascendingSortOrder: false,
        applications: [],
        filters: {
          form: {
            title: "Фильтр заявлений",
            id: "apps-filter",
            width: 12,
            responsive: "",
            horizontal: false,
            horizontalWidth: {
              label: {
                width: 4,
                responsive: "col-sm-5",
              },
              field: {
                width: 8,
                responsive: "col-sm-7",
              },
            },
            disabled: false,
            fields: [
              {
                id: "1",
                label: "№ обращения",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "col-sm-4 col-md-3 col-lg-2",
                value: null,
              },
              {
                id: "2",
                label: "Наименование бизнес-процесса",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "col-sm-8 col-md-6 col-lg-5",
                value: null,
              },
            ],
          },
        },
        pagination: {
          itemsTotal: 0,
          page: 1,
          pageSize: 10,
          itemsPerPage: [10, 25, 50],
        },
        refreshMethod: "getApps",
      },
      settingsForm: {
        notification: {
          form: {
            title: "Настройки уведомления",
            validity: false,
            horizontal: true,
            horizontalWidth: {
              label: {
                width: 4,
                responsive: "col-sm-5",
              },
              field: {
                width: 8,
                responsive: "col-sm-7",
              },
            },
            fields: [
              {
                id: "notification-need",
                label: "Разместить уведомление",
                type: "checkbox",
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                defaultValueLabel: "Выберите",
                horizontal: false,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: false,
              },
              {
                id: "notification-start-immediately",
                label: "Начало публикации сразу после сохранения",
                type: "checkbox",
                width: 12,
                responsive: "",
                required: false,
                disabled: false,
                visibility: false,
                defaultValueLabel: "Выберите",
                horizontal: false,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: false,
              },
              {
                id: "notification-start-date",
                label: "Дата публикации уведомления",
                type: "input",
                subtype: "datetime-local",
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: false,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "notification-finish-manual",
                label: "Снятие с публикации вручную",
                type: "checkbox",
                width: 12,
                responsive: "",
                required: false,
                disabled: false,
                defaultValueLabel: "Выберите",
                horizontal: false,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: false,
              },
              {
                id: "notification-finish-date",
                label: "Дата снятия уведомления с публикации",
                type: "input",
                subtype: "datetime-local",
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: false,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "notification-text",
                label: "Текст уведомления",
                type: "textarea",
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: false,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "notification-font-size",
                label: "Размер",
                type: "select",
                itemsList: [
                  { id: 1, value: 1, label: "Нормальный" },
                  { id: 2, value: 2, label: "Укрупненный" },
                  { id: 3, value: 3, label: "Огромный" },
                ],
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: false,
                defaultValueLabel: "Выберите размер",
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                values: [],
              },
              {
                id: "notification-color",
                label: "Цвет уведомления",
                type: "select",
                itemsList: [
                  { id: 1, value: 1, label: "Синий" },
                  { id: 2, value: 2, label: "Серый" },
                  { id: 3, value: 3, label: "Зелёный" },
                  { id: 4, value: 4, label: "Красный" },
                  { id: 5, value: 5, label: "Жёлтый" },
                  { id: 6, value: 6, label: "Голубой" },
                  { id: 7, value: 7, label: "Светлый" },
                  { id: 8, value: 8, label: "Тёмный" },
                ],
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: false,
                defaultValueLabel: "Выберите цвет",
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                values: [],
              },
            ],
          },
        },
        server: {
          form: {
            title: "Настройки уведомления",
            validity: false,
            horizontal: true,
            horizontalWidth: {
              label: {
                width: 4,
                responsive: "col-sm-5",
              },
              field: {
                width: 8,
                responsive: "col-sm-7",
              },
            },
            fields: [
              {
                id: "server-internal",
                label: "Интерфейс и серверная часть находятся на одном домене",
                type: "checkbox",
                width: 12,
                responsive: "",
                required: false,
                // disabled: false,
                disabled: true,
                visibility: true,
                defaultValueLabel: "Выберите",
                horizontal: false,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: true,
              },
              {
                id: "server-external-address",
                label: "Адрес сервера открытого контура",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: true,
                // disabled: false,
                disabled: true,
                visibility: false,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
            ],
          },
        },
        logo: {
          form: {
            title: "Настройки уведомления",
            validity: false,
            horizontal: true,
            horizontalWidth: {
              label: {
                width: 4,
                responsive: "col-sm-5",
              },
              field: {
                width: 8,
                responsive: "col-sm-7",
              },
            },
            fields: [
              {
                id: "logo-image-file",
                label: "Прикрепленные документы",
                type: "input",
                subtype: "file",
                comment: "Файл логотипа",
                button: {
                  text: "Добавить документ",
                  icon: {
                    url: "/icons/paperclip.svg",
                  },
                },
                file: {
                  name: "",
                  base64: "",
                },
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "logo-brand",
                label: "Наименование организации",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
            ],
          },
        },
        footer: {
          form: {
            title: "Настройки футера",
            validity: false,
            horizontal: true,
            horizontalWidth: {
              label: {
                width: 4,
                responsive: "col-sm-5",
              },
              field: {
                width: 8,
                responsive: "col-sm-7",
              },
            },
            fields: [
              {
                id: "footer-phone",
                label: "Номер телефона",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "footer-email",
                label: "Адрес электронной почты",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "footer-link-01-name",
                label: "Наименование ссылки №1",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "footer-link-01-url",
                label: "Адрес ссылки №1",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: false,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "footer-link-02-name",
                label: "Наименование ссылки №2",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "footer-link-02-url",
                label: "Наименование структуры/организации",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: false,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "footer-link-03-name",
                label: "Наименование ссылки №3",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "footer-link-03-url",
                label: "Адрес ссылки №3",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: false,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
              {
                id: "footer-copyright-need",
                label: "Отображать копирайт",
                type: "checkbox",
                width: 12,
                responsive: "",
                required: false,
                visibility: true,
                defaultValueLabel: "Выберите",
                horizontal: false,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: false,
              },
              {
                id: "footer-copyright-text",
                label: "Текст копирайта",
                type: "input",
                subtype: "text",
                width: 12,
                responsive: "",
                required: true,
                disabled: false,
                visibility: true,
                horizontal: true,
                horizontalWidth: {
                  label: {
                    width: 4,
                    responsive: "col-sm-5",
                  },
                  field: {
                    width: 8,
                    responsive: "col-sm-7",
                  },
                },
                value: "",
              },
            ],
          },
        },
      },
      service: {
        info: {},
        forms: [],
        applicationDTO: {
          active: false,
          data: {},
          form: {
            actions: [],
            id: 0,
            modelId: 0,
            scheme: {},
          },
          id: 0,
          orderId: "",
          status: "",
          loader: {
            isLoading: false,
            isResponse: false,
            comment: "",
          },
        },
        applicationDTOJSONStamp: "",
        form: {
          keepAliveIntervalId: null,
          lastChangeTimestamp: null,
          logoutTimeMin: 1.5,
        },
        loader: {
          loader: {
            isLoading: false,
            isResponse: false,
            comment: "",
          },
        },
      },
      loadedServiceForm: false,
      isLogoutNote: false,
    };
  },

  computed: {
    isAuthUser: function () {
      return !!this.user.shortInfo.userId;
    },
    unreadMessages: function () {
      return this.messagesList.filter((item) => !item.wasRead).length;
    },
    sortedMessagesList: function () {
      let sortedMessages = [];
      this.messagesList.forEach(function (item) {
        sortedMessages.push(item);
      });
      sortedMessages.sort(function (a, b) {
        if (a.receiptDate > b.receiptDate) return 1; // если первое значение больше второго
        if (a.receiptDate == b.receiptDate) return 0; // если равны
        if (a.receiptDate < b.receiptDate) return -1; // если первое значение меньше второго
      });
      return sortedMessages.reverse();
    },
    messageRequestQuery: function () {
      let messageRequestQuery = "app/messages?";
      if (this.user.shortInfo.userId) {
        messageRequestQuery += "userId=" + this.user.shortInfo.userId;
      }
      if (this.messagesTable.filters[0].value) {
        messageRequestQuery += "&id=" + this.messagesTable.filters[0].value;
      }
      if (this.messagesTable.filters[1].itemsList[0].value) {
        messageRequestQuery +=
          "&createDate_start=" +
          this.formatDateForRequest(
            this.messagesTable.filters[1].itemsList[0].value
          );
      }
      if (this.messagesTable.filters[1].itemsList[1].value) {
        messageRequestQuery +=
          "&createDate_end=" +
          this.formatDateForRequest(
            this.messagesTable.filters[1].itemsList[1].value
          );
      }
      if (this.messagesTable.filters[2].value) {
        messageRequestQuery += "&theme=" + this.messagesTable.filters[2].value;
      }
      if (this.messagesTable.filters[3].itemsList[0].value) {
        messageRequestQuery +=
          "&enterStatusDate_start=" +
          this.formatDateForRequest(
            this.messagesTable.filters[3].itemsList[0].value
          );
      }
      if (this.messagesTable.filters[3].itemsList[1].value) {
        messageRequestQuery +=
          "&enterStatusDate_end=" +
          this.formatDateForRequest(
            this.messagesTable.filters[3].itemsList[1].value
          );
      }
      if (this.messagesTable.filters[4].values[0]) {
        messageRequestQuery +=
          "&status=" + this.messagesTable.filters[4].values[0];
      }
      if (this.messagesTable.filters[5].itemsList[0].value) {
        messageRequestQuery +=
          "&sendDate_start=" +
          this.formatDateForRequest(
            this.messagesTable.filters[5].itemsList[0].value
          );
      }
      if (this.messagesTable.filters[5].itemsList[1].value) {
        messageRequestQuery +=
          "&sendDate_end=" +
          this.formatDateForRequest(
            this.messagesTable.filters[5].itemsList[1].value
          );
      }

      messageRequestQuery +=
        "&pageNum=" + (this.messagesTable.pagination.page - 1);

      messageRequestQuery +=
        "&pageSize=" + this.messagesTable.pagination.pageSize;
      messageRequestQuery += "&sortCol=" + this.messagesTable.sortColumn;
      messageRequestQuery +=
        "&sortDesc=" + this.messagesTable.ascendingSortOrder;
      return messageRequestQuery;
    },
    appRequestQuery: function () {
      let appRequestQuery = "app/teachers?";
      if (this.user.shortInfo.userId) {
        appRequestQuery += "userId=" + this.user.shortInfo.userId;
      }
      if (this.appsTable.filters[0].value) {
        appRequestQuery += "&id=" + this.appsTable.filters[0].value;
      }
      if (this.appsTable.filters[1].itemsList[0].value) {
        appRequestQuery +=
          "&createDate_start=" +
          this.formatDateForRequest(
            this.appsTable.filters[1].itemsList[0].value
          );
      }
      if (this.appsTable.filters[1].itemsList[1].value) {
        appRequestQuery +=
          "&createDate_end=" +
          this.formatDateForRequest(
            this.appsTable.filters[1].itemsList[1].value
          );
      }
      if (this.appsTable.filters[2].value) {
        appRequestQuery += "&epguNum=" + this.appsTable.filters[2].value;
      }
      if (this.appsTable.filters[3].values[0]) {
        appRequestQuery += "&status=" + this.appsTable.filters[3].values[0];
      }
      if (this.appsTable.filters[4].itemsList[0].value) {
        appRequestQuery +=
          "&changeStatusDate_start=" +
          this.formatDateForRequest(
            this.appsTable.filters[4].itemsList[0].value
          );
      }
      if (this.appsTable.filters[4].itemsList[1].value) {
        appRequestQuery +=
          "&changeStatusDate_end=" +
          this.formatDateForRequest(
            this.appsTable.filters[4].itemsList[1].value
          );
      }

      appRequestQuery += "&pageNum=" + (this.appsTable.pagination.page - 1);
      appRequestQuery += "&pageSize=" + this.appsTable.pagination.pageSize;
      appRequestQuery += "&sortCol=" + this.appsTable.sortColumn;
      appRequestQuery += "&sortDesc=" + this.appsTable.ascendingSortOrder;
      return appRequestQuery;
    },
    expertiseRequestQuery: function () {
      let expertiseRequestQuery = "app/expertise?";
      if (this.user.shortInfo.userId) {
        expertiseRequestQuery += "userId=" + this.user.shortInfo.userId;
      }
      // expertiseRequestQuery +=
      //   "&archive=" + this.expertisesTable.filters[6].value;
      if (this.expertisesTable.filters[0].value) {
        expertiseRequestQuery += "&id=" + this.expertisesTable.filters[0].value;
      }
      if (this.expertisesTable.filters[1].value) {
        expertiseRequestQuery +=
          "&teacherFIO=" + this.expertisesTable.filters[1].value;
      }
      if (this.expertisesTable.filters[2].itemsList[0].value) {
        expertiseRequestQuery +=
          "&createDate_start=" +
          this.formatDateForRequest(
            this.expertisesTable.filters[2].itemsList[0].value
          );
      }
      if (this.expertisesTable.filters[2].itemsList[1].value) {
        expertiseRequestQuery +=
          "&createDate_end=" +
          this.formatDateForRequest(
            this.expertisesTable.filters[2].itemsList[1].value
          );
      }
      if (this.expertisesTable.filters[3].value) {
        expertiseRequestQuery +=
          "&timeToEnd=" + this.expertisesTable.filters[3].value;
      }
      // if (this.expertisesTable.filters[4].itemsList[0].value) {
      //   expertiseRequestQuery +=
      //     "&???_start=" +
      //     this.formatDateForRequest(
      //       this.expertisesTable.filters[4].itemsList[0].value
      //     );
      // }
      // if (this.expertisesTable.filters[4].itemsList[1].value) {
      //   expertiseRequestQuery +=
      //     "&???_end=" +
      //     this.formatDateForRequest(
      //       this.expertisesTable.filters[4].itemsList[1].value
      //     );
      // }
      if (this.expertisesTable.filters[5].values[0]) {
        expertiseRequestQuery +=
          "&expertiseResult=" + this.expertisesTable.filters[5].values[0];
      }
      if (this.expertisesTable.filters[6].values[0]) {
        expertiseRequestQuery +=
          "&status=" + this.expertisesTable.filters[6].values[0];
      }

      expertiseRequestQuery +=
        "&pageNum=" + (this.expertisesTable.pagination.page - 1);
      expertiseRequestQuery +=
        "&pageSize=" + this.expertisesTable.pagination.pageSize;
      expertiseRequestQuery += "&sortCol=" + this.expertisesTable.sortColumn;
      expertiseRequestQuery +=
        "&sortDesc=" + this.expertisesTable.ascendingSortOrder;
      return expertiseRequestQuery;
    },

    // From 72
    authCompleted: function () {
      let isAuthUser = this.config.user.auth;
      let needSelectRole = !this.config.user.shortInfo.roleId;
      let needSelectOrg =
        !this.config.user.shortInfo.orgId &&
        this.config.user.fullInfo.userOrganizations.length > 0;
      return isAuthUser && !needSelectRole && !needSelectOrg;
    },
    authModalTitle: function () {
      let authModalTitle = "";
      if (!this.config.user.auth) {
        authModalTitle = "Авторизация";
      } else {
        if (this.config.authModalMode === "select-role") {
          authModalTitle = "Выбор роли";
        }
        if (this.config.authModalMode === "select-organization") {
          authModalTitle = "Выбор организации";
        }
      }
      return authModalTitle;
    },
    userFullName: function () {
      let fullName = "";
      if (
        this.config.user.fullInfo.userData &&
        this.config.user.fullInfo.userData.lastName
      ) {
        fullName += this.config.user.fullInfo.userData.lastName;
      }
      if (
        this.config.user.fullInfo.userData &&
        this.config.user.fullInfo.userData.firstName
      ) {
        fullName += " " + this.config.user.fullInfo.userData.firstName;
      }
      if (
        this.config.user.fullInfo.userData &&
        this.config.user.fullInfo.userData.middleName
      ) {
        fullName += " " + this.config.user.fullInfo.userData.middleName;
      }
      return fullName;
    },
    /*unreadMessages: function () {
      return this.messagesList.filter((item) => !item.archived).length;
    },
    sortedMessagesList: function () {
      let sortedMessages = [];
      this.messagesList.forEach(function (item) {
        sortedMessages.push(item);
      });
      sortedMessages.sort(function (a, b) {
        if (a.timestamp > b.timestamp) return 1; // если первое значение больше второго
        if (a.timestamp == b.timestamp) return 0; // если равны
        if (a.timestamp < b.timestamp) return -1; // если первое значение меньше второго
      });
      return sortedMessages.reverse();
    },*/
    appsRequestQuery: function () {
      let appsRequestQuery = "api/app/get-apps?";
      if (this.apps.pagination.page) {
        appsRequestQuery += "pageNum=" + (this.apps.pagination.page - 1);
      }
      if (this.apps.pagination.pageSize) {
        appsRequestQuery += "&pageSize=" + this.apps.pagination.pageSize;
      }
      if (this.apps.sortColumn) {
        appsRequestQuery += "&sortCol=" + this.apps.sortColumn;
      }
      appsRequestQuery += "&sortDesc=" + !this.apps.ascendingSortOrder;
      appsRequestQuery += "&userList=true";
      appsRequestQuery += "&active=false";
      if (this.apps.filters.form.fields[0].value) {
        appsRequestQuery += "&appId=" + this.apps.filters.form.fields[0].value;
      }
      if (this.apps.filters.form.fields[1].value) {
        appsRequestQuery +=
          "&servName=" + this.apps.filters.form.fields[1].value;
      }
      return appsRequestQuery;
    },
    setConfigRequest: function () {
      let setConfigRequest = {
        notification: {
          publishNeed: false,
          publicationImmediately: true,
          publicationStartDate: "",
          publicationFinishManual: true,
          publicationFinishDate: "",
          notificationText: "",
          notificationFontSize: 1,
          notificationColor: 4,
        },
        server: {
          ownServer: true,
          externalServerUrl: "",
        },
        logo: {
          image: {
            file: "/9j/4QR...eFz/2Q==",
            type: "image/jpeg",
            fileName: "Line_Screen.jpg",
          },
          logoBrand: "Информационные системы и сервисы",
        },
        footer: {
          contacts: {
            phone: "8-383-354-1011",
            email: "info@isands.ru",
          },
          links: [
            {
              name: "Поддержка юридических лиц",
              url: "/measures",
            },
            {
              name: "Поддержка физических лиц",
              url: "/measures",
            },
          ],
          copyright: {
            publication: true,
            text: "© Информационные системы и сервисы, 2022",
          },
        },
      };
      if (this.settingsForm.notification.form.fields[0].value) {
        setConfigRequest.notification.publishNeed = true;
        if (this.settingsForm.notification.form.fields[1].value) {
          // Заменить на получение текущей даты
          setConfigRequest.notification.publicationStartDate =
            this.convertDateToInputDateTime(new Date());
        } else {
          setConfigRequest.notification.publicationImmediately = false;
          setConfigRequest.notification.publicationStartDate =
            this.settingsForm.notification.form.fields[2].value;
        }
        if (!this.settingsForm.notification.form.fields[3].value) {
          setConfigRequest.notification.publicationFinishManual = false;
          setConfigRequest.notification.publicationFinishDate =
            this.settingsForm.notification.form.fields[4].value;
        }
        setConfigRequest.notification.notificationText =
          this.settingsForm.notification.form.fields[5].value;
        setConfigRequest.notification.notificationFontSize =
          this.settingsForm.notification.form.fields[6].values[0];
        setConfigRequest.notification.notificationColor =
          this.settingsForm.notification.form.fields[7].values[0];
      }

      setConfigRequest.server = {
        ownServer: this.settingsForm.server.form.fields[0].value,
        externalServerUrl: this.settingsForm.server.form.fields[1].value,
      };
      setConfigRequest.logo = {
        image: {
          file: this.settingsForm.logo.form.fields[0].file.base64,
          type: this.settingsForm.logo.form.fields[0].file.type,
          fileName: this.settingsForm.logo.form.fields[0].file.name,
        },
        logoBrand: this.settingsForm.logo.form.fields[1].value,
      };

      setConfigRequest.footer = {
        contacts: {
          phone: this.settingsForm.footer.form.fields[0].value,
          email: this.settingsForm.footer.form.fields[1].value,
        },
        links: [
          {
            name: this.settingsForm.footer.form.fields[2].value,
            url: this.settingsForm.footer.form.fields[3].value,
          },
          {
            name: this.settingsForm.footer.form.fields[4].value,
            url: this.settingsForm.footer.form.fields[5].value,
          },
          {
            name: this.settingsForm.footer.form.fields[6].value,
            url: this.settingsForm.footer.form.fields[7].value,
          },
        ],
        copyright: {
          publication: this.settingsForm.footer.form.fields[8].value,
          text: this.settingsForm.footer.form.fields[9].value,
        },
      };
      return setConfigRequest;
    },
    dynamicUrl: function () {
      let dynamicUrl;
      if (this.config.adminSettings.server.ownServer) {
        dynamicUrl = this.config.url;
      } else {
        dynamicUrl = this.config.adminSettings.server.externalServerUrl + "/";
      }
      return dynamicUrl;
    },
  },

  methods: {
    // Оптимизация: debounce для методов, которые часто вызываются
    debouncedGetApps: null,
    debouncedGetMessages: null,
    
    // Метод для очистки FormIO компонентов
    cleanupFormIOComponent(component) {
      if (component) {
        try {
          // Удаляем event listeners
          if (component.off) {
            component.off();
          }
          
          // Очищаем данные
          if (component.submission) {
            component.submission.data = null;
            component.submission = null;
          }
          
          // Очищаем схему формы
          if (component.form) {
            component.form = null;
          }
          
          // Вызываем destroy если доступен
          if (component.destroy) {
            component.destroy();
          }
          
          // Очищаем DOM элементы
          if (component.element) {
            component.element.innerHTML = '';
            component.element = null;
          }
        } catch (error) {
          console.error('Ошибка при очистке FormIO компонента:', error);
        }
      }
    },

    // Utility метод для debounce - предотвращает частые вызовы функций
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    // Метод для очистки данных конкретной формы
    cleanFormData(modelId) {
      if (modelId === this.appsServiceId) {
        // Очищаем FormIO компонент если существует
        if (this.$children[3] && this.$children[3].$refs.vueForm && this.$children[3].$refs.vueForm.formio) {
          this.cleanupFormIOComponent(this.$children[3].$refs.vueForm.formio);
        }
        // Очищаем данные формы
        if (this.appForm && this.appForm.data) {
          this.appForm.data = null;
        }
        if (this.appForm && this.appForm.form && this.appForm.form.scheme) {
          this.appForm.form.scheme = null;
        }
      } else if (modelId === this.messagesServiceId) {
        if (this.messageForm && this.messageForm.data) {
          this.messageForm.data = null;
        }
        if (this.messageForm && this.messageForm.form && this.messageForm.form.scheme) {
          this.messageForm.form.scheme = null;
        }
      } else if (modelId === this.expertisesServiceId) {
        if (this.expertiseForm && this.expertiseForm.data) {
          this.expertiseForm.data = null;
        }
        if (this.expertiseForm && this.expertiseForm.form && this.expertiseForm.form.scheme) {
          this.expertiseForm.form.scheme = null;
        }
      }
      
      // Принудительная сборка мусора (если поддерживается)
      if (window.gc) {
        setTimeout(() => window.gc(), 100);
      }
    },

    // Принудительная очистка памяти при критических ошибках
    forceMemoryCleanup() {
      console.log('Принудительная очистка памяти из-за ошибки');
      
      // Очищаем все формы
      this.cleanFormData(this.appsServiceId);
      this.cleanFormData(this.messagesServiceId);
      this.cleanFormData(this.expertisesServiceId);
      
      // Очищаем большие массивы данных
      if (this.appsResponse && this.appsResponse.length > 100) {
        this.appsResponse = this.appsResponse.slice(0, 50); // Оставляем только первые 50 элементов
      }
      if (this.messagesResponse && this.messagesResponse.length > 100) {
        this.messagesResponse = this.messagesResponse.slice(0, 50);
      }
      if (this.expertisesResponse && this.expertisesResponse.length > 100) {
        this.expertisesResponse = this.expertisesResponse.slice(0, 50);
      }
      
      // Триггерим сборку мусора
      if (window.gc) {
        setTimeout(() => window.gc(), 500);
      }
    },

    // Косвенная проверка авторизованности пользователя, получение ссылки на вход через ЕСИА (переход на страницу авторизации ЕСИА - вынести во внешний метод)
    async getLogin() {
      await axios(this.url + "api/auth/get-login", {
        withCredentials: true,
      })
        .then((response) => {
          console.groupCollapsed("Ссылка на авторизацию ЕСИА");
          console.log(response.data);
          console.groupEnd();
          location.href = response.data.url;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 406) {
              console.log("Пользователь уже авторизован");
              this.user.isAuth = true;
            } else if (error.response.status === 404) {
              console.log(
                "Проверка авторизованности пользователя не удалась. Ошибка при составлении ссылки на вход ЕСИА со стороны закрытой части"
              );
            } else if (error.response.status === 500) {
              console.log(
                "Проверка авторизованности пользователя не удалась. Ошибка со стороны открытой части при отправке запроса получения ссылки на вход ЕСИА на закрытую часть"
              );
            } else {
              console.log(
                "Непредвиденная ошибка при выполнении запроса auth/get-login"
              );
            }
          }
        });
    },
    // Вход по логину и паролю
    signInLocal(signInData) {
      this.loaderStart(this.authLoader, "Проверка данных пользователя");
      this.user.signInData = signInData;
      axios
        .post(this.url + "api/auth/local-login", signInData, {
          withCredentials: true,
        })
        .then(async () => {
          await this.getUserId();
          await this.getUserInfo();
          this.signInDataReset();
          // this.$refs["nav-sidebar"].hide();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.authErrorLog("password", "Неверно указан пароль!");
          } else if (error.response.status === 404) {
            this.authErrorLog(
              "login",
              "Пользователь с указанным логином не зарегистрирован!"
            );
          } else if (error.response.status === 406) {
            console.log(
              "Попытка авторизованного пользователя авторизоваться ещё раз"
            );
            this.authErrorLog(
              "client",
              "Пользователь уже авторизован. Повторная авторизация не требуется"
            );
          } else if (error.response.status === 500) {
            console.log(
              "Ошибка открытого контура при выполнении запроса локальной авторизации на закрытый контур"
            );
            this.authErrorLog(
              "server",
              "Произошла ошибка при выполнении запроса авторизации. Пожалуйста обратитесь к администратору системы. Код ошибки - 500"
            );
          } else if (error.response.status === 501) {
            console.log(
              "Ошибка закрытого контура при выполнении запроса локальной авторизации"
            );
            this.authErrorLog(
              "server",
              "Произошла ошибка при выполнении запроса авторизации. Пожалуйста обратитесь к администратору системы. Код ошибки - 501"
            );
          } else {
            console.log(
              "Непредвиденная ошибка при выполнении запроса локальной авторизации"
            );
            this.authErrorLog(
              "server",
              "Произошла непредвиденная ошибка при выполнении запроса авторизации. Пожалуйста обратитесь к администратору системы"
            );
          }
        })
        .then(() => {
          setTimeout(this.loaderFinish, this.loadersDelay, this.authLoader);
        });
    },
    // Запись ошибок авторизации
    authErrorLog(errorType, errorComment) {
      this.authError.type = errorType;
      this.authError.text = errorComment;
    },
    // Сброс данных авторизации и ошибок авторизации
    signInDataReset() {
      this.user.signInData = {
        login: "",
        password: "",
      };
      this.authErrorLog("", "");
    },

    // Выбор роли пользователя при авторизации по логину/паролю
    // signInWithRole(role, hideModal) {
    signInWithRole(role) {
      axios
        .put(this.url + "api/core/put-metadata?orgId=0&roleId=" + role.id, "", {
          withCredentials: true,
        })
        .then((response) => {
          this.user.shortInfo = response.data;
          this.user.selectedRole = role;
          this.cleanSignInForm();

          localStorage.setItem('selectedRoleId', role.id);

          console.groupCollapsed("Пользователь авторизован с ролью");
          console.log(role);
          console.groupEnd();
        });
    },

    // Получение информации о пользователе
    async getUserId() {
      await axios(this.url + "api/auth/get-user", {
        withCredentials: true,
      })
        .then((response) => {
          console.groupCollapsed("Идентификатор пользователя");
          console.log(response.data);
          console.groupEnd();
          this.user.shortInfo = response.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 404) {
              console.log("Данные текущего пользователя не найдены");
            } else {
              console.log(
                "Непредвиденная ошибка при выполнении запроса auth/get-user"
              );
            }
          }
        });
    },
    async getUserInfo() {
      await axios(this.url + "api/core/get-user", {
        withCredentials: true,
      })
        .then((response) => {
          console.groupCollapsed("Данные пользователя");
          console.log(response.data);
          console.groupEnd();
          this.user.fullInfo = response.data;

          const savedRoleId = localStorage.getItem('selectedRoleId');
            if (savedRoleId) {
              let savedRole = this.user.fullInfo.roles.find(r => r.id == savedRoleId || r.roleId == savedRoleId);
              if (savedRole) {
                this.setRole(savedRole.id || savedRole.roleId);
                return;
              }
          }

          if (this.user.fullInfo.roles.length === 0) {
            // this.$refs["modal-auth"].hide();
            console.log("У пользователя отсутствуют роли");
            // Принудительно выставляем роль "Педагогический работник"
            // Поиск роли "Педагогический работник" в справочнике ролей
            let teacherRole = null;
            if (this.dictionaries && this.dictionaries.jobGroups) {
              teacherRole = this.dictionaries.jobGroups.find(r => r.label === "Педагогический работник");
            }
            // Если справочник не загружен, создаём роль вручную
            if (!teacherRole) {
              teacherRole = { id: this.teacherRoleId, label: "Педагогический работник" };
              // Добавляем роль в массив, чтобы HomeView увидел её
              this.user.fullInfo.roles = [teacherRole];
            } else {
              // Если нашли роль в справочнике, тоже добавляем её
              this.user.fullInfo.roles = [teacherRole];
            }
              this.initUserRole(teacherRole);
              // Принудительно меняем роль на "Педагогический работник"
              this.setRole(teacherRole.id);
          } else {
            // Принудительно выставляем роль expertRoleId, если есть, иначе teacherRoleId
            let expertRole = this.user.fullInfo.roles.find(r => r.id == this.expertRoleId || r.roleId == this.expertRoleId);
            let teacherRole = this.user.fullInfo.roles.find(r => r.id == this.teacherRoleId || r.roleId == this.teacherRoleId);
            let forcedRole = expertRole || teacherRole;
            if (forcedRole) {
              this.setRole(forcedRole.id || forcedRole.roleId);
            } else {
              // Если ни одной из ролей нет, оставляем стандартное поведение
              let currentRole = this.getRoleById(this.user.shortInfo.roleId);
              if (currentRole) {
                this.initUserRole(currentRole);
              }
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 404) {
              console.log(
                "Ошибка запроса данных текущего пользователя неавторизованным пользователем"
              );
            this.notifySessionExpired();

              
            } else if (error.response.status === 401) {
              console.log(
                "Ошибка получения данных при выполнении запроса данных текущего пользователя"
              );
            } else {
              console.log(
                "Непредвиденная ошибка при выполнении запроса core/get-user"
              );
            }
          }
        });
    },
    // Присвоение текущей роли пользователю
    initUserRole(role) {
      this.user.selectedRole = role;
      this.userSelectedRoleId = this.user.shortInfo.roleId;
      console.groupCollapsed("Пользователь проинициализирован с ролью");
      console.log(role);
      console.groupEnd();
    },

    // Смена роли пользователя
    setRole(roleId) {
      this.loaderStart(this.authLoader, "Смена роли пользователя");
      axios
        .put(this.url + "api/core/put-metadata?orgId=0&roleId=" + roleId, "", {
          withCredentials: true,
        })
        .then((response) => {
          // this.$emit("change-user-short-info", response.data);
          // this.$emit("select-role", role);
          this.user.shortInfo = response.data;
          let role = this.getRoleById(roleId);
          this.user.selectedRole = role;
          this.userSelectedRoleId = role.id;

          localStorage.setItem('selectedRoleId', roleId);

          console.log(
            "Роль пользователя изменена на роль с идентификатором " +
              role.label +
              "(id = " +
              role.id +
              ")"
          );
          if (this.user.shortInfo.roleId === this.teacherRoleId) {
            this.getTeacher();
          } else if (this.user.shortInfo.roleId === this.expertRoleId) {
            this.getExpert();
          }
          startSessionInterval();
        })
        .then(() => {
          setTimeout(this.loaderFinish, this.loadersDelay, this.authLoader);
        });
    },
    getRoleById(roleId) {
      let role;
      this.user.fullInfo.roles.some(function (roleItem) {
        if (roleItem.id === roleId) {
          role = roleItem;
          return roleItem;
        }
      });
      if (!role) {
        console.log(`Роль по идентификатору ${roleId} не найдена `);
      }
      return role;
    },

    // Уведомление об истечении сессии и выход
    notifySessionExpired() {
      if (this.isLogoutNote) return; // не показывать повторно
      this.isLogoutNote = true;
      // alert("Ваша сессия истекла. Пожалуйста, войдите в систему снова.");
      // заменить на компонент сообщения
      this.isLogoutNote = false;
      this.signOut();
    },

    // Выход
    signOut() {
      if (this.user.shortInfo.typeAuth === "local") {
        this.signOutLocal();
      }
      if (this.user.shortInfo.typeAuth === "esia") {
        this.getLogout();
      }
    },
    // Локальный выход
    signOutLocal() {
      this.loaderStart(this.authLoader, "Выход из системы");

      // Очистка локального и сессионного хранилища и cookies при выходе
      localStorage.clear();
      sessionStorage.clear();

      localStorage.removeItem('selectedRoleId');

      // Удаление всех cookies для текущего домена
      document.cookie.split(';').forEach(function(c) {
        document.cookie = c
          .replace(/^ +/, '')
          .replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/');
      });

      axios(this.url + "api/auth/local-logout", {
        withCredentials: true,
      })
        .then(() => {
          this.user = {
            signInData: {
              login: "",
              password: "",
            },
            shortInfo: {
              userId: null,
              userName: "",
              roleId: null,
              orgId: null,
              typeAuth: "",
            },
            fullInfo: {
              roles: [],
              userData: {
                lastName: "",
                firstName: "",
                middleName: "",
                birthDate: "",
                citizenship: "",
                gender: "",
                snils: "",
              },
              contacts: [{ value: "" }],
            },
            selectedRole: {
              id: null,
              key: "",
              label: "",
            },
          };
          console.log("Выход пользователя из системы");
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            console.log(
              "Попытка неавторизованного пользователя осуществить локальный выход из системы"
            );
          } else {
            console.log("Непредвиденная ошибка локального выхода из системы");
          }
        })
        .then(() => {
          setTimeout(this.loaderFinish, this.loadersDelay, this.authLoader);
          // this.$refs["nav-sidebar"].hide();
          if (this.$route.path !== "/") {
            this.$router.push("/");
          }
          // Принудительная перезагрузка страницы для очистки состояния
          window.location.reload(true); // С очисткой кеша
        });
    },
    // Выход через ЕСИА
    getLogout() {
      // Очистка локального и сессионного хранилища и cookies при выходе через ЕСИА
      localStorage.clear();
      sessionStorage.clear();

      localStorage.removeItem('selectedRoleId');
      
      document.cookie.split(';').forEach(function(c) {
        document.cookie = c
          .replace(/^ +/, '')
          .replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/');
      });

      axios(this.url + "api/auth/get-logout", {
        withCredentials: true,
      })
        .then((response) => {
          console.log("Ссылка на выход ЕСИА");
          console.log(response);
          // location.href = response.data.url;
          this.esiaLogoutLink = response.data.url;
          this.user.shortInfo = {
            userId: null,
            userName: "",
            typeAuth: "",
          };
          this.user.fullInfo = {
            roles: [],
          };
          location.href = response.data.url;
        })
        .catch((error) => {
          console.log("Ошибка выхода есиа");
          console.log(error);
        })
        .then(() => {
          this.$router.push("/");
        });
    },

    // Очистка ошибок
    cleanSignInForm() {
      // this.login = "";
      // this.password = "";
      this.authError.type = "";
      this.authError.text = "";
    },

    // Получение списка заявлений пользователя
    // getApps(
    //   page = this.appsTable.pagination.pageSize,
    //   pageSize = this.appsTable.pagination.pageSize,
    //   servId = this.appsServiceId,
    //   sortCol = this.appsTable.sortColumn,
    //   sortDesc = !this.appsTable.ascendingSortOrder,
    //   userList = true,
    //   active = false
    // ) {
    //   axios
    //     .get(
    //       this.url +
    //         "app/get-apps?pageNum=" +
    //         (page - 1) +
    //         "&pageSize=" +
    //         pageSize +
    //         "&servId=" +
    //         servId +
    //         "&sortCol=" +
    //         sortCol +
    //         "&sortDesc=" +
    //         sortDesc +
    //         "&userList=" +
    //         userList +
    //         "&active=" +
    //         active,
    //       {
    //         withCredentials: true,
    //       }
    //     )
    //     .then((response) => {
    //       this.appsResponse = response.data.content;
    //       this.appsTable.rowsList = this.appsConvertToTable(
    //         response.data.content
    //       );
    //       this.appsTable.pagination.itemsTotal = response.data.totalElements;
    //       console.groupCollapsed("Список заявлений");
    //       console.log(response.data.content);
    //       console.groupEnd();
    //     });
    // },
    async getApps() {
      const fullUrl = this.urlAdd + this.appRequestQuery;
      await axios
        .get(fullUrl, {
          withCredentials: true,
        })
        .then((response) => {
          this.appsResponse = response.data.content;
          this.appsTable.rowsList = this.appsConvertToTable(
            response.data.content
          );
          this.appsTable.pagination.itemsTotal = response.data.totalElements;
          console.groupCollapsed("Список заявлений");
          console.log(response.data.content);
          console.groupEnd();
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && this.user.shortInfo.userId) {
            this.notifySessionExpired();
          }
          // Очищаем данные при ошибке
          this.appsResponse = [];
          this.appsTable.rowsList = [];
          this.appsTable.pagination.itemsTotal = 0;
          console.error("Ошибка получения заявлений:", error);
        })
        .finally(() => {
        });
    },
    // appsConvertToTable(apps) {
    //   let appsTable = [];
    //   apps.forEach(function (app) {
    //     let appsTableItem = [];
    //     appsTableItem.push(app.externalId);
    //     appsTableItem.push(app.servName);
    //     appsTableItem.push(app.startDate.substring(0, 10));
    //     appsTableItem.push("---");
    //     appsTableItem.push(app.status);
    //     appsTableItem.push("---");
    //     appsTable.push(appsTableItem);
    //   });
    //   return appsTable;
    // },
    appsConvertToTable(apps) {
      let appsTable = [];
      // let getDictionaryValueById = this.getDictionaryValueById;
      apps.forEach(function (app) {
        let appsTableItem = [];
        if (app.id) {
          appsTableItem.push(app.id);
        } else {
          appsTableItem.push("");
        }
        if (app.serviceName) {
          appsTableItem.push(app.serviceName);
        } else {
          appsTableItem.push("");
        }
        if (app.createDate) {
          appsTableItem.push(app.createDate.substring(0, 10));
        } else {
          appsTableItem.push("");
        }
        if (app.epguNum) {
          appsTableItem.push(app.epguNum);
        } else {
          appsTableItem.push("");
        }
        if (app.status) {
          appsTableItem.push(
            // getDictionaryValueById("statusModel_2", app.status)
            app.status
          );
        } else {
          appsTableItem.push("");
        }
        if (app.changeStatusDate) {
          appsTableItem.push(app.changeStatusDate.substring(0, 10));
        } else {
          appsTableItem.push("");
        }

        appsTable.push(appsTableItem);
      });
      return appsTable;
    },
    clearAppsFilter() {
      this.appsTable.filters[0].value = null;
      this.appsTable.filters[1].itemsList[0].value = null;
      this.appsTable.filters[1].itemsList[1].value = null;
      this.appsTable.filters[2].value = null;
      this.appsTable.filters[3].values = [];
      this.appsTable.filters[4].itemsList[0].value = null;
      this.appsTable.filters[4].itemsList[1].value = null;
      this.appsTable.filters[5].value = false;
      this.getApps();
    },

    // Получение списка заявлений пользователя
    async getMessages() {
      await axios
        .get(this.urlAdd + this.messageRequestQuery, {
          withCredentials: true,
        })
        .then((response) => {
          this.messagesResponse = response.data.content;
          this.messagesTable.rowsList = this.messagesConvertToTable(
            response.data.content
          );
          this.messagesTable.pagination.itemsTotal =
            response.data.totalElements;
          console.groupCollapsed("Список сообщений");
          console.log(response.data.content);
          console.groupEnd();
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && this.user.shortInfo.userId) {
            this.notifySessionExpired();
          }
        })
        .finally(() => {
        });
    },
    messagesConvertToTable(messages) {
      let messagesTable = [];
      let getDictionaryValueById = this.getDictionaryValueById;
      messages.forEach(function (message) {
        let messagesTableItem = [];
        if (message.id) {
          messagesTableItem.push(message.id);
        } else {
          messagesTableItem.push("");
        }
        if (message.createDate) {
          messagesTableItem.push(message.createDate.substring(0, 10));
        } else {
          messagesTableItem.push("");
        }
        if (message.theme && message.theme) {
          messagesTableItem.push(message.theme);
        } else {
          messagesTableItem.push("");
        }
        if (message.dateEnterStatusStart) {
          messagesTableItem.push(message.dateEnterStatusStart.substring(0, 10));
        } else {
          messagesTableItem.push("");
        }
        if (message.status) {
          messagesTableItem.push(
            getDictionaryValueById("statusModel_1", message.status)
          );
        } else {
          messagesTableItem.push("");
        }
        if (message.responseTime) {
          messagesTableItem.push(message.responseTime);
        } else {
          messagesTableItem.push("");
        }
        messagesTable.push(messagesTableItem);
      });
      return messagesTable;
    },

    // Изменения фильтра
    changeFilter(filters, newFilterData) {
      let filterItem = filters.find(function (item) {
        if (item.id === newFilterData.id) return true;
      });
      if (filterItem.type === "select") {
        filterItem.values = [newFilterData.value];
      } else if (filterItem.type === "range") {
        filterItem.itemsList[newFilterData.index].value = newFilterData.value;
      } else {
        filterItem.value = newFilterData.value;
      }
    },
    formatDateForRequest(dateInputFormat) {
      let arrayDateInput = dateInputFormat.split("-");
      let requestFormatDate =
        arrayDateInput[2] + "." + arrayDateInput[1] + "." + arrayDateInput[0];
      return requestFormatDate;
    },
    clearMessagesFilter() {
      this.messagesTable.filters[0].value = null;
      this.messagesTable.filters[1].itemsList[0].value = null;
      this.messagesTable.filters[1].itemsList[1].value = null;
      this.messagesTable.filters[2].value = "";
      this.messagesTable.filters[3].itemsList[0].value = null;
      this.messagesTable.filters[3].itemsList[1].value = null;
      this.messagesTable.filters[4].values = [];
      this.messagesTable.filters[5].itemsList[0].value = null;
      this.messagesTable.filters[5].itemsList[1].value = null;
      this.getMessages();
    },

    // Получение списка заявлений пользователя
    // getExpertises(
    //   page = this.expertisesTable.pagination.pageSize,
    //   pageSize = this.expertisesTable.pagination.pageSize,
    //   servId = this.expertisesServiceId,
    //   sortCol = this.expertisesTable.sortColumn,
    //   sortDesc = !this.expertisesTable.ascendingSortOrder,
    //   userList = true,
    //   active = false
    // ) {
    //   axios
    //     .get(
    //       this.url +
    //         "app/get-apps?pageNum=" +
    //         (page - 1) +
    //         "&pageSize=" +
    //         pageSize +
    //         "&servId=" +
    //         servId +
    //         "&sortCol=" +
    //         sortCol +
    //         "&sortDesc=" +
    //         sortDesc +
    //         "&userList=" +
    //         userList +
    //         "&active=" +
    //         active,
    //       {
    //         withCredentials: true,
    //       }
    //     )
    //     .then((response) => {
    //       this.expertisesResponse = response.data.content;
    //       this.expertisesTable.rowsList = this.expertisesConvertToTable(
    //         response.data.content
    //       );
    //       this.expertisesTable.pagination.itemsTotal =
    //         response.data.totalElements;
    //       console.groupCollapsed("Список экспертиз");
    //       console.log(response.data.content);
    //       console.groupEnd();
    //     });
    // },
    async getExpertises() {
      this.isLoading = true;
      await axios
        .get(this.urlAdd + this.expertiseRequestQuery, {
          withCredentials: true,
        })
        .then((response) => {
          this.expertisesResponse = response.data.content;
          this.expertisesTable.rowsList = this.expertisesConvertToTable(
            response.data.content
          );
          this.expertisesTable.pagination.itemsTotal =
            response.data.totalElements;
          console.groupCollapsed("Список экспертиз");
          console.log(response.data.content);
          console.groupEnd();
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && this.user.shortInfo.userId) {
            this.notifySessionExpired();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    expertisesConvertToTable(expertises) {
      let expertisesTable = [];
      let getDictionaryValueById = this.getDictionaryValueById;
      expertises.forEach(function (expertise) {
        let expertisesTableItem = [];
        if (expertise.id) {
          expertisesTableItem.push(expertise.id);
        } else {
          expertisesTableItem.push("");
        }
        if (expertise.teacherFIO) {
          expertisesTableItem.push(expertise.teacherFIO);
        } else {
          expertisesTableItem.push("");
        }
        if (expertise.dateExpertiseStart) {
          expertisesTableItem.push(
            expertise.dateExpertiseStart.substring(0, 10)
          );
        } else {
          expertisesTableItem.push("");
        }
        // if (expertise.timeToEnd) {
        //   expertisesTableItem.push(expertise.timeToEnd);
        // } else {
        //   expertisesTableItem.push("");
        // }
        if (expertise.dateExpertiseEnd) {
          expertisesTableItem.push(expertise.dateExpertiseEnd.substring(0, 10));
        } else {
          expertisesTableItem.push("");
        }
        if (expertise.resultExpertise) {
          expertisesTableItem.push(
            getDictionaryValueById("resultExpert", expertise.resultExpertise)
          );
        } else {
          expertisesTableItem.push("");
        }
        if (expertise.status) {
          expertisesTableItem.push(
            // getDictionaryValueById("statusModel_3", expertise.status)
            expertise.status
          );
        } else {
          expertisesTableItem.push("");
        }

        expertisesTable.push(expertisesTableItem);
      });
      return expertisesTable;
    },
    clearExpertisesFilter() {
      this.expertisesTable.filters[0].value = null;
      this.expertisesTable.filters[1].value = null;
      this.expertisesTable.filters[2].itemsList[0].value = null;
      this.expertisesTable.filters[2].itemsList[1].value = null;
      this.expertisesTable.filters[3].value = null;
      this.expertisesTable.filters[4].itemsList[0].value = null;
      this.expertisesTable.filters[4].itemsList[1].value = null;
      this.expertisesTable.filters[5].values = [];
      this.expertisesTable.filters[6].values = [];
      this.getExpertises();
    },

    // Список записей журнала действий
    async getAudit() {
      await axios
        .get(this.urlAdd + "data/getAudit", {
          withCredentials: true,
        })
        .then((response) => {
          this.auditResponse = response.data;
          let logsTableRows = this.logsConvertToTable(response.data).reverse();
          this.logsTable.rowsList = logsTableRows;
          this.logsTable.pagination.itemsTotal = logsTableRows.length;
          console.groupCollapsed("Список записей журнала");
          console.log(this.logsConvertToTable(response.data));
          console.groupEnd();
        });
    },
    logsConvertToTable(logs) {
      let logsTable = [];
      if (logs.length > 0) {
        logs.forEach((item) => {
          let logItem = [];
          logItem.push(item.id);
          logItem.push(item.eventDate.substring(0, 10));
          logItem.push(item.description);
          logItem.push(item.event);
          let changesList = JSON.parse(item.changes).changes;
          let changesText = "";
          changesList.forEach((changeItem) => {
            changesText += changeItem.name + " - " + changeItem.new_v + "; ";
          });
          logItem.push(changesText);
          logsTable.push(logItem);
        });
      }
      return logsTable;
    },

    // Стартовая форма заявления
    async getStartForm(serviceId, id) {
      if (serviceId === this.appsServiceId) {
        this.loaderStart(this.appsLoader, "Загрузка формы заявления");
      } else if (serviceId === this.messagesServiceId) {
        this.loaderStart(this.messagesLoader, "Загрузка формы сообщения");
      } else if (serviceId === this.expertisesServiceId) {
        this.loaderStart(this.expertisesLoader, "Загрузка формы экспертизы");
      }
      if (id) {
        await this.getForm(serviceId, id);
      } else {
        await this.getForm(serviceId);
      }
    },
    async getForm(serviceId, appId) {
      let requestUrl;
      if (appId) {
        if (serviceId === this.appsServiceId) {
          requestUrl =
            this.url +
            "api/app/=" +
            this.appsResponse.find((app) => app.id === appId).appId;
          console.log("Запрос формы существующего заявления");
        } else if (serviceId === this.messagesServiceId) {
          requestUrl =
            this.url +
            "api/app/get-appData?id=" +
            this.messagesResponse.find((message) => message.id === appId).appId;
          console.log("Запрос формы существующего сообщения");
        } else if (serviceId === this.expertisesServiceId) {
          requestUrl =
            this.url +
            "api/app/get-appData?id=" +
            this.expertisesResponse.find((expertise) => expertise.id === appId)
              .appId;
          console.log("Запрос формы существующей экспертизы");
        }
      } else {
        requestUrl =
          // this.url + "api/serv/get-appData?id=" + this.$route.params.modelId;
          this.url + "api/serv/get-appData?id=" + serviceId;
        if (serviceId === this.appsServiceId) {
          console.log("Запрос стартовой формы заявления");
        } else if (serviceId === this.messagesServiceId) {
          console.log("Запрос стартовой формы сообщения");
        }
      }
      await axios
        .get(requestUrl, {
          withCredentials: true,
        })
        .then((response) => {
          console.groupCollapsed("Стартовая форма");
          console.log(response.data.applicationDTO);
          console.groupEnd();
          const newForm = response.data.applicationDTO;
          newForm.data = JSON.parse(newForm.data);
          newForm.form.scheme = JSON.parse(newForm.form.scheme);
          if (serviceId === this.appsServiceId) {
            this.appForm = newForm;
          } else if (serviceId === this.messagesServiceId) {
            this.messageForm = newForm;
          } else if (serviceId === this.expertisesServiceId) {
            this.expertiseForm = newForm;
          }
        })
        .then(() => {
          if (serviceId === this.appsServiceId) {
            this.loaderFinish(this.appsLoader);
          } else if (serviceId === this.messagesServiceId) {
            this.loaderFinish(this.messagesLoader);
          } else if (serviceId === this.expertisesServiceId) {
            this.loaderFinish(this.expertisesLoader);
          }
        });
    },

    validateForm() {
      console.log("Проверка валидности формы");
      // console.log(this);
      return this.$children[3].$refs.vueForm.formio.checkValidity(
        this.$children[3].$refs.vueForm.formio.submission.data
      );
    },

    invokeAction(action) {
      console.log("Выполнение действия с id=" + action.actionId);
      this.isFirstLoad = false;
      this.isValidFormData = this.validateForm();
      console.log("Валидность формы:" + this.isValidFormData);
      if (this.isValidFormData) {
        if (action.modelId === this.appsServiceId) {
          this.loaderStart(this.appsLoader, "Выполнение действия по заявлению");
        } else if (action.modelId === this.messagesServiceId) {
          this.loaderStart(
            this.messagesLoader,
            "Выполнение действия по сообщению"
          );
        } else if (action.modelId === this.expertisesServiceId) {
          this.loaderStart(
            this.expertisesLoader,
            "Выполнение действия по экспертизе"
          );
        }
        setTimeout(
          this.invoke,
          1000,
          action.actionId,
          action.backAction,
          action.modelId
        );
      } else {
        this.$children[3].$refs.vueForm.formio.submit();
      }
    },
    invoke(actionId, isBackAction = false, modelId) {
      let formId;
      let formData;
      if (modelId === this.appsServiceId) {
        formId = this.appForm.id;
        formData = JSON.stringify(this.appForm.data);
      } else if (modelId === this.messagesServiceId) {
        formId = this.messageForm.id;
        formData = JSON.stringify(this.messageForm.data);
      } else if (modelId === this.expertisesServiceId) {
        formId = this.expertiseForm.id;
        formData = JSON.stringify(this.expertiseForm.data);
      }
      const request = {
        actionId: actionId,
        // userId: this.user.shortInfo.userId,
        appId: formId,
        data: formData,
        userId: this.user.shortInfo.userId,
        roleId: this.user.shortInfo.roleId,
        orgId: this.user.shortInfo.orgId,
      };
      axios
        .post(this.url + "api/app/action-invoke", request, {
          withCredentials: true,
        })
        .then((response) => {
          console.log("Ответ на экшн");
          console.log(response);
          if (response.data.responseObject) {
            let fileApp = null;
            try {
              fileApp = JSON.parse(response.data.responseObject);
              console.log("Объект файла");
              console.log(fileApp);
              // Создаем временный элемент для скачивания файла
              let link = document.createElement("a");
              link.setAttribute("download", fileApp.fileName);
              link.setAttribute(
                "href",
                "data:application/octet-stream;base64," + fileApp.fileData
              );
              document.body.appendChild(link); // Добавляем в DOM
              link.click();
              // ВАЖНО: удаляем элемент после использования для освобождения памяти
              setTimeout(() => {
                if (link && document.body.contains(link)) {
                  document.body.removeChild(link);
                }
                link = null; // Очищаем ссылку
              }, 100);
            } catch (parseError) {
              console.error("Ошибка парсинга файла:", parseError);
            } finally {
              // Очищаем данные файла из памяти
              fileApp = null;
            }
          } else {
            if (isBackAction) {
              this.cleanAppForm(modelId);
            } else {
              this.getNextForm(actionId, response, modelId);
            }
          }
        })
        .catch((error) => {
          // КРИТИЧНО: Обработка ошибок для предотвращения утечек памяти
          console.error("Ошибка выполнения действия:", error);
          
          // Очищаем данные форм при ошибке
          this.cleanFormData(modelId);
          
          // Показываем пользователю сообщение об ошибке
          if (error.response && error.response.status === 400) {
            console.error("Ошибка 400 - некорректные данные заявления");
            // Дополнительная очистка при 400 ошибке
            this.forceMemoryCleanup();
          }
          
          // Финишируем загрузку в любом случае
          if (modelId === this.appsServiceId) {
            this.loaderFinish(this.appsLoader);
          } else if (modelId === this.messagesServiceId) {
            this.loaderFinish(this.messagesLoader);
          } else if (modelId === this.expertisesServiceId) {
            this.loaderFinish(this.expertisesLoader);
          }
          
          this.isFirstLoad = true;
        })
        .finally(() => {
          // Важно: очистка в блоке finally для освобождения памяти в любом случае
          formData = null;
          
          if (modelId === this.appsServiceId) {
            this.debouncedGetApps(); // Используем debounced версию
            this.loaderFinish(this.appsLoader);
          } else if (modelId === this.messagesServiceId) {
            this.debouncedGetMessages(); // Используем debounced версию
            this.loaderFinish(this.messagesLoader);
          } else if (modelId === this.expertisesServiceId) {
            // this.getExpertises();
            this.sortTable("expertisesTable", 0);
            this.loaderFinish(this.expertisesLoader);
          }
          this.isFirstLoad = true;
        });
    },

    // Переход к следующей форме (стандартное действие)
    getNextForm(actionId, response, modelId) {
      console.log("Следующая форма");
      console.log(response);
      
      // ВАЖНО: Очищаем предыдущие данные формы перед созданием новых
      this.cleanFormData(modelId);
      
      let nextForm = null;
      try {
        nextForm = response.data.applicationDTO;
        nextForm.data = JSON.parse(nextForm.data);
        nextForm.form.scheme = JSON.parse(nextForm.form.scheme);
        
        if (modelId === this.appsServiceId) {
          this.appForm = nextForm;
        } else if (modelId === this.messagesServiceId) {
          this.messageForm = nextForm;
        } else if (modelId === this.expertisesServiceId) {
          this.expertiseForm = nextForm;
        }
        
        this.successComment = "Заявление отправлено!";
        console.log(this.$children[3].$refs.vueForm);
      } catch (parseError) {
        console.error("Ошибка парсинга данных формы:", parseError);
        this.cleanFormData(modelId);
      }
    },

    cleanAppForm(modelId = this.appsServiceId) {
      // this.modal.hide();
      let modal = new Modal(document.getElementById("modalId"));
      console.log(modal);
      modal.hide();
      console.log("Очищаю форму");
      console.log(this);
      
      // Очищаем данные в зависимости от типа формы
      this.cleanFormData(modelId);
      
      this.isLoading = false;
      this.loadingComment = "Загрузка формы заявления";
      this.successComment = "Форма заявления успешно загружена!";
      this.isResponse = true;
      this.isAlertVisible = true;
      this.isValidFormData = false;
      this.isFirstLoad = true;
    },

    // Пагинация
    changePageSize(list, newPageInfo, serviceId) {
      console.log(list);
      console.log(newPageInfo);
      console.log(serviceId);
      list.pagination.page = newPageInfo[0];
      list.pagination.pageSize = newPageInfo[1];
      if (serviceId === this.appsServiceId) {
        this.getApps();
      } else if (serviceId === this.messagesServiceId) {
        this.getMessages();
      } else if (serviceId === this.expertisesServiceId) {
        this.getExpertises();
      }
    },
    changePage(list, page, serviceId) {
      list.pagination.page = page;
      if (serviceId === this.appsServiceId) {
        this.getApps();
      } else if (serviceId === this.messagesServiceId) {
        this.getMessages();
      } else if (serviceId === this.expertisesServiceId) {
        this.getExpertises();
      }
    },

    // Лоадер
    loaderStart(loader, loaderComment) {
      loader.isResponse = false;
      loader.isLoading = true;
      loader.comment = loaderComment;
    },
    loaderFinish(loader) {
      loader.isResponse = true;
      loader.isLoading = false;
    },

    // Редактирование профиля
    editProfile() {
      this.loaderStart(this.profileLoader, "Редактирование личных данных");
      setTimeout(this.loaderFinish, this.loadersDelay, this.profileLoader);
    },

    // Получение списка мер
    async getServises() {
      await axios
        .get(
          this.url +
            "serv/get-services?pageNum=0&pageSize=100&sortCol=id&sortDesc=false&active=true",
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          // this.measuresCardsList = response.data.content;
          // this.itemsTotal = response.data.totalElements;
          console.groupCollapsed("Список мер поддержки");
          console.log(response.data);
          console.groupEnd();
          // window.scrollTo(0, 0);
        });
    },

    // Уведомления
    readMessage(messageId) {
      console.log(messageId);
      let message = this.messagesList.find((item) => item.id === messageId);
      if (!message.wasRead) {
        message.wasRead = true;
      }
      message.wasRead = true;
    },
    deleteMessage(messageId) {
      console.log(messageId);
      let messageIndex = this.messagesList.findIndex(
        (item) => item.id === messageId
      );
      this.messagesList.splice(messageIndex, 1);
    },

    // Данные личного кабинета
    async getTeacher() {
      await axios
        .get(this.urlAdd + "teacher/get", {
          withCredentials: true,
        })
        .then((response) => {
          this.teacherInfo = response.data;
          if (!response.data.birthday) {
            this.teacherInfo.birthday = "";
          }
          if (!response.data.issueDate) {
            this.teacherInfo.issueDate = "";
          }
          if (!response.data.docValidate) {
            this.teacherInfo.docValidate = "";
          }
          this.teacherInfo.subjectArea = JSON.parse(response.data.subjectArea);
          console.groupCollapsed("Личные данные педагога");
          console.log(response.data);
          console.groupEnd();
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    setTeacher() {
      this.loaderStart(this.profileLoader, "Сохранение личных данных");
      this.teacherInfo.subjectArea = JSON.stringify(
        this.teacherInfo.subjectArea
      );
      axios
        .post(this.urlAdd + "teacher/edit", this.teacherInfo, {
          withCredentials: true,
        })
        .then((response) => {
          this.getTeacher();
          console.groupCollapsed("Ответ на редактирование данных педагога");
          console.log(response.data);
          console.groupEnd();
        })
        .catch(() => {
          console.log(
            "Непредвиденная шибка при сохранении личных данных учителя"
          );
        })
        .then(() => {
          setTimeout(this.loaderFinish, this.loadersDelay, this.profileLoader);
        });
    },
    async getExpert() {
      await axios
        .get(this.urlAdd + "expert/get", {
          withCredentials: true,
        })
        .then((response) => {
          this.expertInfo = response.data;
          this.analyticsTable.rowsList.length = 0;
          this.analyticsTable.rowsList.push(
            this.analyticsConvertToTable(response.data)
          );
          this.expertInfo.subjectArea = JSON.parse(response.data.subjectArea);
          console.groupCollapsed("Личные данные эксперта");
          console.log(response.data);
          console.groupEnd();
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    setExpert() {
      this.loaderStart(this.profileLoader, "Сохранение личных данных");
      this.expertInfo.subjectArea = JSON.stringify(this.expertInfo.subjectArea);
      axios
        .post(this.urlAdd + "expert/edit", this.expertInfo, {
          withCredentials: true,
        })
        .then((response) => {
          this.getExpert();
          console.groupCollapsed("Ответ на редактирование данных эксперта");
          console.log(response.data);
          console.groupEnd();
        })
        .catch(() => {
          console.log(
            "Непредвиденная шибка при сохранении личных данных эксперта'"
          );
        })
        .then(() => {
          setTimeout(this.loaderFinish, this.loadersDelay, this.profileLoader);
        });
    },
    analyticsConvertToTable(expertData) {
      let analyticsRowsList = [];
      analyticsRowsList.push(expertData.numberExaminations);
      analyticsRowsList.push(expertData.numberPositiveResult);
      analyticsRowsList.push(expertData.numberNegativeResult);
      analyticsRowsList.push(expertData.numberCoincidences);
      return analyticsRowsList;
    },

    // Словари
    async getAllDictionaries() {
      Promise.all([
        this.getDictionary("gender", '"Пол"'),
        this.getDictionary("subjectArea", '"Предметная область"'),
        this.getDictionary("jobGroups", '"Должность"'),
        this.getDictionary(
          "municipalEntityIrkutsk",
          '"Муниципальные образования"'
        ),
        this.getDictionary(
          "DocumentPersonal",
          '"Документы, удостоверяющие личность"'
        ),
        this.getDictionary("statusModel_2", '"Статусы заявлений"'),
        this.getDictionary("statusModel_1", '"Статусы сообщений"'),
        this.getDictionary("statusModel_3", '"Статусы экспертиз"'),
        this.getDictionary("resultExpert", '"Результаты экспертиз"'),
      ]).then(() => {
        console.log("Справочники загружены");
      });
      // this.getDictionary("topic", '"Темы сообщений"'),
    },
    async getDictionary(dictionaryCode, logComment) {
      await axios
        .get(this.url + "api/core/get-dictdata?code=" + dictionaryCode, {
          withCredentials: true,
        })
        .then((response) => {
          this.dictionaries[dictionaryCode] = this.convertDictionary(
            response.data
          );
          console.groupCollapsed("Справочник" + logComment);
          console.log(response.data);
          console.groupEnd();
        })
        .then(() => {
          this.setDictionaryToSelect(dictionaryCode);
        })
        .catch(() => {
          console.log(
            'Непредвиденная ошибка при выполнении запроса справочника "' +
              logComment +
              '"'
          );
        });
    },
    convertDictionary(dictionary) {
      let convertedDictionary = [];
      dictionary.forEach((dictionaryItem) => {
        let convertedItem = {};
        convertedItem.id = dictionaryItem.value;
        convertedItem.label = dictionaryItem.label;
        convertedItem.value = dictionaryItem.value;
        convertedDictionary.push(convertedItem);
      });
      return convertedDictionary;
    },
    getDictionaryValueById(dictionaryName, id) {
      let dictionary = this.dictionaries[dictionaryName];
      let dictionaryItem = dictionary.find((item) => item.value === id);
      // console.log('dictionaryItem', dictionaryItem);
      return dictionaryItem ? dictionaryItem.label : "Не определен";
    },
    setDictionaryToSelect(dictionaryCode) {
      if (dictionaryCode === "statusModel_1") {
        this.messagesTable.filters[4].itemsList =
          this.dictionaries.statusModel_1;
      }
      if (dictionaryCode === "statusModel_2") {
        this.appsTable.filters[3].itemsList = this.dictionaries.statusModel_2;
      }
      if (dictionaryCode === "statusModel_3") {
        this.expertisesTable.filters[6].itemsList =
          this.dictionaries.statusModel_3;
      }
      if (dictionaryCode === "resultExpert") {
        this.expertisesTable.filters[5].itemsList =
          this.dictionaries.resultExpert;
      }
      // if (dictionaryCode === "topic") {
      //   this.messagesTable.filters[2].itemsList = this.dictionaries.topic;
      // }
    },

    // Файлы для работы с системой
    async getFileResources() {
      await axios
        .get(this.urlAdd + "data/getFileResources", {
          withCredentials: true,
        })
        .then((response) => {
          this.fileResources = response.data.content;
          console.groupCollapsed("Файлы для работы с системой");
          console.log(response.data);
          console.groupEnd();
        })
        .catch(() => {
          console.log(
            "Непредвиденная ошибка при выполнении запроса файлов для работы с системой"
          );
        });
    },
    // График аттестации
    async getGakJournal() {
      await axios
        .get(this.urlAdd + "data/getGakJournal", {
          withCredentials: true,
        })
        .then((response) => {
          this.expertisesSchedule = this.parseGakJournal(response.data);
          console.groupCollapsed("Расписание аттестации");
          console.log(response.data);
          console.groupEnd();
        })
        .catch(() => {
          console.log(
            "Непредвиденная ошибка при выполнении запроса расписания аттестации"
          );
        });
    },

    parseGakJournal(xml) {
      let startIndex = xml.indexOf("<table");
      let finishIndex = xml.indexOf("</table>") + 8;
      let tableString = xml.slice(startIndex, finishIndex);
      return tableString;
    },

    openNotify() {
      $("#notify").modal("show");
    },
    afterCloseNotify() {
      console.log("Модалка закрылась");
      console.log(this);
      if (this.$route.path !== "/") {
        this.$router.push("/");
        // window.location.reload();
      }
    },

    checkAuth() {  // нигде не используется
      axios(this.url + "api/auth/get-login", {
        withCredentials: true,
      }).then(() => {
        this.openNotify();
      });
    },

    sortTable(tableName, columnIndex) {
      let table = this[tableName];
      let columnSortName = table.columnsList[columnIndex].name;
      table.pagination.page = 1;
      if (table.sortColumn === columnSortName) {
        table.ascendingSortOrder = !table.ascendingSortOrder;
      } else {
        table.ascendingSortOrder = true;
        table.sortColumn = columnSortName;
      }
      if (table.service === this.appsServiceId) {
        this.getApps();
      } else if (table.service === this.messagesServiceId) {
        this.getMessages(
          table.pagination.page,
          table.pagination.pageSize,
          this.messagesServiceId,
          columnSortName,
          !table.ascendingSortOrder
        );
      } else if (table.service === this.expertisesServiceId) {
        this.getExpertises(
          table.pagination.page,
          table.pagination.pageSize,
          this.expertisesServiceId,
          columnSortName,
          !table.ascendingSortOrder
        );
      }
    },

    // From 72
    // ----------Методы для формио из formio.full.min.js----------
    // Первая форма обращения
    // Детальная информация по сервису
    async showServiceInfo(serviceId) {
      await this.getServiceInfo(serviceId);
      if (this.$route.params.serviceId !== serviceId) {
        this.goToView("/service-info/" + serviceId);
      }
    },
    async getServiceInfo(serviceId) {
      await axios
        .get(this.dynamicUrl + "api/serv/get-model?id=" + serviceId)
        .then((response) => {
          this.service.info = response.data;
          this.service.info.newDescription = JSON.parse(
            response.data.newDescription
          );
          console.groupCollapsed(
            `Детальная информация по сервису "${response.data.name}"`
          );
          console.log(response.data);
          console.groupEnd();
        });
    },
    async showServiceFirstForm({ serviceId, loaderComment }) {
      this.loaderStart(this.appsLoader, loaderComment);
      console.log("Запуск массива запросов на получение первой формы");
      Promise.all([
        // this.getServiceInfo(serviceId),
        // this.getServiceForms(serviceId),
        this.getServiceForm(serviceId),
      ]).then(() => {
        this.loaderFinish(this.appsLoader);
        this.loadedServiceForm = !this.loadedServiceForm;
        console.log(
          "Первая форма, детальная информация по сервису и формы сервиса загружены"
        );
      });
    },
    // Форма существующего заявления
    async showAppForm({ serviceId, appId, loaderComment }) {
      this.loaderStart(this.appsLoader, loaderComment);
      console.log(
        `Необходимо получить обращение ${appId} по сервису ${serviceId}`
      );
      Promise.all([
        // this.getServiceInfo(serviceId),
        // this.getServiceForms(serviceId),
        this.getServiceForm(serviceId, appId),
      ]).then(() => {
        this.loaderFinish(this.appsLoader);
        this.loadedServiceForm = !this.loadedServiceForm;
        console.log(
          "Форма существующего обращения (не первая), детальная информация по сервису и формы сервиса загружены"
        );
      });
    },
    async getServiceForms(serviceId) {
      // console.log(`Запрос форм по БП - ${serviceId}`);
      await axios
        .get(this.dynamicUrl + "api/serv/get-forms?id=" + serviceId, {
          withCredentials: true,
        })
        .then((response) => {
          console.groupCollapsed("Формы по мере поддержки");
          console.log(response.data);
          console.groupEnd();
          this.service.forms = response.data;
        });
    },
    async getServiceForm(serviceId, appId) {
      // console.log(`Запрос первой формы по БП - ${serviceId}`);
      let requestUrl;
      if (appId) {
        if (serviceId === this.appsServiceId) {
          const appObj = this.appsResponse.find((app) => app.id === appId);
          if (appObj && appObj.appId) {
            requestUrl = this.url + "api/app/get-appData?id=" + appObj.appId;
            console.log("Запрос формы существующего заявления");
          } else {
            console.error("App not found for appId:", appId);
            return;
          }
        } else if (serviceId === this.messagesServiceId) {
          const msgObj = this.messagesResponse.find((message) => message.id === appId);
          if (msgObj && msgObj.appId) {
            requestUrl = this.url + "api/app/get-appData?id=" + msgObj.appId;
            console.log("Запрос формы существующего сообщения");
          } else {
            console.error("Message not found for appId:", appId);
            return;
          }
        } else if (serviceId === this.expertisesServiceId) {
          const expObj = this.expertisesResponse.find((expertise) => expertise.id === appId);
          if (expObj && expObj.appId) {
            requestUrl = this.url + "api/app/get-appData?id=" + expObj.appId;
            console.log("Запрос формы существующей экспертизы");
          } else {
            console.error("Expertise not found for appId:", appId);
            return;
          }
        }
        // console.log(
        //   `Запрос существующей (не первой) формы сервиса с id = ${serviceId}`
        // );
      } else {
        requestUrl = this.dynamicUrl + "api/serv/get-appData?id=" + serviceId;
        // console.log(`Запрос первой формы сервиса с id = ${serviceId}`);
      }
      
      // Очищаем предыдущие данные формы перед загрузкой новых
      if (this.service.applicationDTO && this.service.applicationDTO.data) {
        this.service.applicationDTO.data = null;
        this.service.applicationDTO.form.scheme = null;
      }
      
      await axios
        .get(requestUrl, {
          withCredentials: true,
        })
        .then((response) => {
          if (appId) {
            console.groupCollapsed("Не стартовая форма сервиса");
          } else {
            console.groupCollapsed("Стартовая форма сервиса");
          }
          console.log(response.data.applicationDTO);
          console.groupEnd();
          
          let serviceForm = null;
          try {
            serviceForm = response.data.applicationDTO;
            serviceForm.data = JSON.parse(serviceForm.data);
            serviceForm.form.scheme = JSON.parse(serviceForm.form.scheme);
            this.service.applicationDTO = serviceForm;
            this.service.applicationDTOJSONStamp = JSON.stringify(serviceForm);
          } catch (parseError) {
            console.error("Ошибка парсинга данных сервиса:", parseError);
            // Очищаем данные при ошибке парсинга
            if (this.service.applicationDTO) {
              this.service.applicationDTO.data = null;
              this.service.applicationDTO.form.scheme = null;
            }
          }
        })
        .catch((error) => {
          console.error("Ошибка загрузки формы сервиса:", error);
          // При ошибке очищаем данные для освобождения памяти
          if (this.service.applicationDTO) {
            this.service.applicationDTO.data = null;
            this.service.applicationDTO.form.scheme = null;
          }
        });
    },
    changeAppForm(applicationDTO) {
      // console.log(applicationDTO);
      console.log("***Меняется форма");
      
      // Очищаем предыдущие данные перед обновлением
      if (this.service.applicationDTO && this.service.applicationDTO.data) {
        // Глубокая очистка предыдущих данных
        this.service.applicationDTO.data = null;
      }
      
      this.service.applicationDTO = applicationDTO;
      this.service.form.lastChangeTimestamp = Date.now();
      this.config.keepAliveSession = true;
    },
    resetAppForm() {
      this.service.applicationDTO = JSON.parse(
        this.service.applicationDTOJSONStamp
      );
    },
    setApplicationStamp(application) {
      this.service.applicationDTOJSONStamp = JSON.stringify(application);
    },
    async updateRegistries() {
      Promise.all([
        this.getMessages(),
        this.getApps(),
        this.getExpertises(),
        this.getAudit(),
      ]).then(() => {
        console.log("Реестры обновлены");
      });
    },
    async getHomeViewData() {
      if (!this.user.shortInfo.userId) {
        await this.getUserId();
      }
      if (this.user.shortInfo.userId && !this.user.fullInfo.userId) {
        await this.getUserInfo();
      }
      let homeViewRequests = [];
      if (!this.fileResources.length) {
        homeViewRequests.push(this.getFileResources());
      }
      if (!this.expertisesSchedule) {
        homeViewRequests.push(this.getGakJournal());
      }
      await Promise.all(homeViewRequests).then(() => {
        console.log(
          "Общедоступные сведения, необходимые для главной страницы, доступны"
        );
      });
    },
    async getAccountViewData(tabName) {
      if (!this.user.shortInfo.userId) {
        await this.getUserId();
      }
      if (this.user.shortInfo.userId && !this.user.fullInfo.userId) {
        await this.getUserInfo();
      }
      if (tabName === "basic-tab") {
        if (this.user.shortInfo.roleId === this.teacherRoleId) {
          if (!this.dictionaries.statusModel_2.length) {
            await this.getDictionary("statusModel_2", '"Статусы заявлений"');
          }
          if (!this.appsResponse.length) {
            await this.getApps();
          }
        } else if (this.user.shortInfo.roleId === this.expertRoleId) {
          let expertisesTabRequests = [];
          if (!this.dictionaries.statusModel_3.length) {
            expertisesTabRequests.push(
              this.getDictionary("statusModel_3", '"Статусы экспертиз"')
            );
          }
          if (!this.dictionaries.resultExpert.length) {
            expertisesTabRequests.push(
              this.getDictionary("resultExpert", '"Результаты экспертиз"')
            );
          }
          await Promise.all([expertisesTabRequests]);
          if (!this.expertisesResponse.length) {
            await this.getExpertises();
          }
        }
      }
      if (tabName === "messages-tab") {
        if (!this.dictionaries.statusModel_1.length) {
          await this.getDictionary("statusModel_1", '"Статусы сообщений"');
        }
        if (!this.messagesResponse.length) {
          await this.getMessages();
        }
      }
      if (tabName === "teacher-info-tab") {
        if (!this.teacherInfo.id) {
          await this.getTeacher();
        }
      }
      if (tabName === "expert-info-tab") {
        let expertInfoTabRequests = [];
        if (!this.dictionaries.municipalEntityIrkutsk.length) {
          expertInfoTabRequests.push(
            this.getDictionary(
              "municipalEntityIrkutsk",
              '"Муниципальные образования"'
            )
          );
        }
        if (!this.dictionaries.jobGroups.length) {
          expertInfoTabRequests.push(
            this.getDictionary("jobGroups", '"Должность"')
          );
        }
        if (!this.dictionaries.subjectArea.length) {
          expertInfoTabRequests.push(
            this.getDictionary("subjectArea", '"Предметная область"')
          );
          await Promise.all([expertInfoTabRequests]);
          if (!this.expertInfo.id) {
            await this.getExpert();
          }
        }
      }
      if (tabName === "analytics-tab") {
        if (!this.expertInfo.id) {
          await this.getExpert();
          await this.expertInfo();
        }
        console.log(
          "Cведения для вкладки «Аналитика» личного кабинета эксперта доступны"
        );
      }
      if (tabName === "actions-journal-tab") {
        if (!this.auditResponse.length) {
          await this.getAudit();
        }
        console.log(
          "Cведения для вкладки «Журнал действий» личного кабинета эксперта доступны"
        );
      }
    },
  },

  created() {
    // Инициализируем debounced методы для оптимизации памяти
    this.debouncedGetApps = this.debounce(this.getApps, 300);
    this.debouncedGetMessages = this.debounce(this.getMessages, 300);

    // Регистрируем коллбэк для уведомления об истечении сессии
    setOnSessionExpired(this.notifySessionExpired);

    // From 72
    window.applicationDTO = this.service.applicationDTO;
  },

  mounted: async function () {
    // Событие при закрытии модального окна
    $("#notify").on("hidden.bs.modal", this.afterCloseNotify);

    // Получение общих сведений
    /*Promise.all([
      this.getLogin(),
      this.getFileResources(),
      this.getGakJournal(),
      this.getAllDictionaries(),
      this.getServises(),
    ]).then(() => {
      console.log("Приложение загружено");
      this.appLoaded = true;
    });*/
  },

  watch: {
    // From 72
    /*"config.keepAliveSession": async function () {
      if (this.config.keepAliveSession) {
        console.log("Запуск интервальных запросов");
        this.service.form.keepAliveIntervalId = setInterval(
          this.keepAliveSession,
          30000
        );
      }
    },*/
  },

  // Добавляем lifecycle hooks для очистки ресурсов
  beforeDestroy() {
    stopSessionInterval();

    // Очистка интервалов
    if (this.authIntervalId) {
      clearInterval(this.authIntervalId);
      this.authIntervalId = null;
    }
    
    if (this.service.form.keepAliveIntervalId) {
      clearInterval(this.service.form.keepAliveIntervalId);
      this.service.form.keepAliveIntervalId = null;
    }
    
    // Очистка event listeners
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    window.removeEventListener('load', this.loadHandler);
    
    // Очистка больших объектов
    this.appsResponse = null;
    this.messagesResponse = null;
    this.expertisesResponse = null;
    this.auditResponse = null;
    
    // Очистка FormIO компонентов
    if (this.vueForm) {
      this.cleanupFormIOComponent(this.vueForm);
      this.vueForm = null;
    }
    
    if (this.modal) {
      if (this.modal.destroy) this.modal.destroy();
      this.modal = null;
    }
  },

  destroyed() {
    // Дополнительная очистка
    console.log('App component destroyed, memory cleaned');
  },
};
</script>
